/* eslint-disable react/destructuring-assignment */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unsafe-optional-chaining */
import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import ProgressButton from "react-progress-button";
import axios from "axios";
import { CollapsiblePanel } from "@components/common";
import utils from "@utils";
import {
	ContactService,
	JobService,
	PaymentService,
	OfficerService,
	OrganizationService,
	ClientService,
	ProjectService,
	LocationService,
	PayCodesService,
	ClientJobRequestService,
	JobEventDraftsService,
} from "@services";
import { GOOGLE_MAP_SETTINGS, FORM_JOB_TYPES, PAY_RATE_TYPE, JOB_INVOICED_TYPES } from "@constants";
import { ANALYTICS_EVENTS_ACTIONS, ANALYTICS_EVENTS_CATEGORIES } from "@constants/analyticsEvents";
import AnalyticsService from "@services/AnalyticsService";
import { cloneDeep, isEmpty } from "@utils/lodash";
import {
	GeneralInformation,
	PositionFormModal,
	PaymentDetails,
	OfficerFulfillment,
	LocationMap,
	PositionSummary,
	PositionSummaryForm,
	InvoicingDetails,
	SendEstimateButton,
} from "./components";
import { ConflictsModal, SendEstimateModal } from "./components/modals";
import {
	AsyncSelect,
	ConfirmationModal,
	AddContactModal,
	SeriesConfirmationModal,
	Loader,
	ReactSelect,
	Tooltip,
} from "../../../components";

import "./Form.scss";

let cancelJobEstimate;

const positionFilterOptions = [
	{ label: "By Name", value: 1 },
	{ label: "Position Rank", value: 2 },
	{ label: "Position Time", value: 3 },
];
const emptyPosition = {
	_isValid: false,
	_needsMultipleOfficers: false,
	_isRovingPatrol: false,
	_assetsRequired: false,
	_positionStartDate: "",
	_startTime: "",
	_endTime: "",
	_certificationRequired: false,
	_hasAssignedOfficers: false,
	_initialRate: "",
	_isRankRequired: false,
	_isMaxRankRequired: false,
	_hasRankRestriction: false,
	Title: "",
	OfficersNeeded: "1",
	Rate: "",
	Details: "",
	SupervisorPosition: false,
	RequestedOfficerRankId: "",
	MaxRequestedOfficerRankId: "",
	OfficerRankRequired: false,
	RovingPatrol: "",
	RequiredJurisdictionAssets: [],
	VehicleRequired: false,
	VehicleTypes: [],
	JobCertifications: [],
	DressTypeId: 1,
	DressTypeNote: "",
	OfficerRequirements: "",
	FlexJob: false,
	FlexJobMinHours: "",
};

class Form extends Component {
	constructor(props) {
		super(props);
		/* FE-1161: Defaulting the agency contact options to the logged in user since
		 * non-staff admin LEA users need at least one option for their name to appear
		 * in the ReactSelect field. This is immediately overwritten for all other users so it
		 * doesn't impact usability or functionality in any way */
		const {
			user,
			params,
			location,
			user: {
				ContactId,
				LastName,
				FirstName,
				Organization: { IsPayCodeMandatory },
			},
		} = props;
		const {
			flags: {
				workersCompensationFee,
				invoicingDetailsComponentEnabled,
				defaultClientValuesCloningJob,
				enforceV2NonrkpayInvoicingEnabled,
				jobDescriptionAttachments,
				relocateJobFormAddToInvoicingV3Button,
			},
		} = props;

		this.hasWorkersCompensationFee = !!workersCompensationFee;
		this.isInvoicingDetailsComponentEnabled = !!invoicingDetailsComponentEnabled;
		this.isDefaultClientValuesCloningJobEnabled = !!defaultClientValuesCloningJob;
		this.jobDescriptionAttachments = !!jobDescriptionAttachments;
		this.enforceV2NonRKPayInvoicingEnabled = !!enforceV2NonrkpayInvoicingEnabled;
		this.relocateJobFormAddToInvoicingV3Button = !!relocateJobFormAddToInvoicingV3Button;

		this.isInvoicingFirstEnabled =
			(user.isLEA() || user.isCoordinator() || user.isAgencyAdmin() || user.IsStaffAdmin) &&
			user.isInvoicingV3();
		this.isNewJob =
			!params?.jobId &&
			!location.query?.jobId &&
			!location.query?.requestId &&
			!location.query?.draftId;
		const { HOURLY, PAY_CODE } = PAY_RATE_TYPE;

		this.initialSeriesConfirmationModal = {
			show: false,
			actionType: "",
			onConfirm: () => {},
			onClose: () => {},
		};

		this.state = {
			pageTitle: "Create a Job / Estimate",
			draftButtonState: "",
			saveButtonState: "",
			estimateButtonState: "disabled",
			showSendEstimateModal: false,
			loadingForm: false,
			loaderEntireScreen: false,
			loadingEstimate: false,
			positionsUpdated: false,
			estimateJurisdictionName: "",
			estimatePostOption: "manual",
			agencyContacts: [{ value: ContactId, label: `${LastName}, ${FirstName}` }],
			clientContacts: [],
			showAddContactModal: false,
			addContactModalType: "",
			positionFilter: null,
			locationCoordinates: {
				...GOOGLE_MAP_SETTINGS.defaultCenter,
			},
			agencyPaymentInvoiceSettings: {
				TransferPaymentToJurisdiction: false,
				TransferPaymentsToAgencyOption: false,
			},
			form: {
				generalInfo: {
					_expanded: false,
					_clientId: "",
					_startDate: "",
					_startTime: "",
					_endTime: "",
					_isRecurring: false,
					_includeCoordinators: false,
					_flexJob: false,
					_flexJobMinHours: "",
					Name: "",
					JobEventTags: [],
					ProjectId: "",
					LocationId: "",
					JobEventTypeId: 1,
					Details: "",
					JobEventRecurrenceRule: {
						RepeatType: 1,
						RepeatsOn: [],
						WeekFrequency: "1",
						EndsAfterOccurrence: "",
						StartsOn: "",
						EndType: "NEVER",
						EndsOn: "",
						CustomDates: [],
					},
					ShowClientContactToOfficer: false,
					ClientSupervisorContactId: "",
					SupervisorContactId: "",
					SecondarySupervisorModel: [],
				},
				positions: {
					_expanded: false,
					Jobs: [],
				},
				paymentDetails: {
					_expanded: false,
					_expandedBenefits: true,
					IsRKPay: false,
					IsScheduling: false,
					JobInvoicedTypeId: null,
					RequirePrepayment: false,
					OrganizationFee: "",
					ClientBillingContactId: "",
					WaiveJurisdictionFees: false,
					TransferPaymentsToAgency: false,
					PaymentMethod: "",
					ClientPaysForTheJob: null,
					ElectronicallyBilled: null,
					TermsAndConditionsAcknowledge: false,
					ExcludeOfficerRate: false,
				},
				officerFulfillment: {
					_expanded: false,
					_usingRestrictions: false,
					ExcludedJurisdictions: [],
					RequiredJurisdictions: [],
				},
			},
			isGeneralInfoValid: false,
			isPositionsValid: false,
			isPaymentDetailsValid: false,
			isOfficerFulfillmentValid: false,
			estimateInfo: {},
			invoiceEstimate: {
				RequireClientInvoiceEstimateApproval: false,
				SendClientInvoiceEstimate: false,
				ClientInvoiceEstimateContactId: "",
				ClientInvoiceEstimateJurisdictionId: null,
			},
			originalSendEstimateSettings: {},
			agencyRules: {
				OnlyAuthorizedClientsAreAllowedToUseVehicles: false,
				RequireInvoicingForVehicles: false,
			},
			jobEditingProperties: {
				Id: null,
				Deleted: false,
				UpdateOnlyChanged: true,
				updateAllUpcoming: undefined,
				JobEventRecurrenceRuleId: null,
				_prevJobType: null,
				_userOwnsJob: true,
				_isExternalSupervisor: false,
			},
			jobRequestProperties: {},
			showInvalidFields: false,
			showPositionFormModal: false,
			activePositionIndex: undefined,
			activePositionGroup: undefined,
			seriesConfirmationModal: { ...this.initialSeriesConfirmationModal },
			createDateUTC: undefined,
			isJobPaidFor: false,
			positionName: "",
			positionStartDate: "",
			positionEndDate: "",
			officersNeeded: "",
			officerRate: "",
			positionStartTime: "",
			positionEndTime: "",
			agencyEstimateList: [],
			showAgencyV3Options: false,
			isJobCompleted: false,
			isPositionValid: true,
			isEditingDate: "",
			newDate: "",
			positionRate: IsPayCodeMandatory ? PAY_CODE : HOURLY,
			PayCodeId: null,
			PTAEOCodeId: null,
			agencyPayCodes: [],
			agencyPTAEOCodes: [],
			rawAgencyPayCodes: [],
			positionWithPayCodeExist: false,
			applyPTAEOcode: false,
			clients: [],
			loadingClients: false,
			loadingProjects: false,
			projects: [],
			loadingLocations: false,
			locations: [],
			loadingSchedulingOptions: false,
			isClientEnforceV2NonRKPayInvoicing: false,
		};

		if (this.jobDescriptionAttachments) {
			this.state.form.generalInfo.JobEventAttachments = [];
		}

		this.timeMask = [/[0-1]/, /[0-9]/, ":", /[0-5]/, /[0-9]/, " ", /(A|P)/i, /M/i];
		this.dateMask = [/[0-1]/, /[0-9]/, "/", /[0-3]/, /[0-9]/, "/", /2/, /0/, /[2-9]/, /[0-9]/];

		this.formSections = createRef();
		this.locationMap = createRef();
		this.estimateContainer = createRef();

		// Modal refs
		this.confirmationModal = createRef();
		this.conflictsModal = createRef();
		this.jobRequestClientModal = createRef();
	}

	componentDidMount() {
		const { user, params, location } = this.props;

		if (user.IsViewOnly) {
			window.location.replace("/jobs/list/active");
		}

		if (params?.jobId) {
			this.loadJobDetails(params.jobId, true);
		} else if (location.query?.jobId) {
			this.loadJobDetails(location.query.jobId);
		} else if (location.query?.requestId) {
			this.loadJobRequest(location.query.requestId);
		} else if (location.query?.draftId) {
			this.loadJobDraft(location.query.draftId);
		}

		this.getPayCodes();
		this.getPTAEOCodes();

		if (user.isLEA() && user.IsInternalCoordinator) {
			this.updateForm("generalInfo", { SupervisorContactId: user.ContactId });
		}

		if (user.IsInternalCoordinator || user.isLEA()) {
			this.getPaymentRules();
			this.getAgencyRules();
		}

		const { Organization, IsRKPay, IsScheduling, IsInternalCoordinator, ContactId } = user;

		this.setState(prevState => {
			const {
				estimateJurisdictionName: prevJurisdictionName,
				invoiceEstimate: { ClientInvoiceEstimateJurisdictionId: prevJurisdictionId },
			} = prevState;

			return {
				estimateJurisdictionName: user.isLEA()
					? (Organization.JurisdictionName ?? "")
					: prevJurisdictionName,
				form: {
					...prevState.form,
					generalInfo: {
						...prevState.form.generalInfo,
						_expanded: !this.isInvoicingFirstEnabled,
						SupervisorContactId:
							user.isLEA() && IsInternalCoordinator && this.isNewJob
								? ContactId
								: prevState.form.generalInfo.SupervisorContactId,
					},
					paymentDetails: {
						...prevState.form.paymentDetails,
						IsRKPay: IsRKPay || false,
						IsScheduling: IsScheduling || false,
						_expanded: this.isInvoicingFirstEnabled,
					},
				},
				invoiceEstimate: {
					...prevState.invoiceEstimate,
					ClientInvoiceEstimateJurisdictionId: user.isLEA()
						? (Organization.JurisdictionId ?? null)
						: prevJurisdictionId,
				},
			};
		});

		const observer = new IntersectionObserver(
			([entry]) => {
				// In an array of entries, we only care about the first one
				const estimateInfoContainer = document.getElementById("estimate-info-container");
				if (
					!entry.isIntersecting &&
					estimateInfoContainer &&
					this.shouldEstimateBeSticky(this.estimateContainer, this.formSections)
				) {
					estimateInfoContainer.classList.add("fix-estimate-container");
				} else if (estimateInfoContainer) {
					estimateInfoContainer.classList.remove("fix-estimate-container");
				}
			},
			{ root: null, rootMargin: "0px", threshold: 0 },
		);

		if (this.locationMap.current) observer.observe(this.locationMap.current);
		document.addEventListener("click", this.clickEventListener);
	}

	componentDidUpdate(prevProps, prevState) {
		const { lang } = global;
		const {
			form: {
				generalInfo: {
					_startDate: prevStartDate,
					_startTime: prevJobStartTime,
					_endTime: prevJobEndTime,
					JobEventTypeId: prevJobEventTypeId,
				},
			},
			// positionStartDate : prevPositionStartDate,
		} = prevState;

		const {
			form: {
				generalInfo: {
					_startDate: jobStartDate,
					_startTime: jobStartTime,
					_endTime: jobEndTime,
					JobEventTypeId,
					_clientId,
				},
				positions: { Jobs },
			},
			agencyRules: { OnlyAuthorizedClientsAreAllowedToUseVehicles },
			clients,
			jobEditingProperties: { Id: editJobId },
			// positionStartDate,
			loadingClients,
			loadingForm,
			positionsUpdated,
		} = this.state;

		const isEditingJob = editJobId !== null;
		const wasJobEvent = prevJobEventTypeId === FORM_JOB_TYPES.EVENT.value;
		const isJobEvent = JobEventTypeId === FORM_JOB_TYPES.EVENT.value;

		if (
			!isEditingJob &&
			(prevJobStartTime !== jobStartTime ||
				prevJobEndTime !== jobEndTime ||
				wasJobEvent !== isJobEvent)
		) {
			const newJobs = Jobs.map(job => {
				let _isValid =
					job.Title.trim() !== "" &&
					job.Rate.toString().trim() !== "" &&
					(isJobEvent
						? job._startTime.trim() !== "" && job._endTime.trim() !== ""
						: jobStartTime.trim() !== "" && jobEndTime.trim() !== "");
				if (utils.isIE || utils.isDesktopSafari) {
					_isValid =
						_isValid &&
						(isJobEvent
							? job._startTime.replace(/_/g, "").length === 8 &&
								job._endTime.replace(/_/g, "").length === 8
							: jobStartTime.replace(/_/g, "").length === 8 &&
								jobEndTime.replace(/_/g, "").length === 8);
				}
				const newJob = {
					...job,
					_isValid,
				};

				if (wasJobEvent && !isJobEvent) {
					newJob._startTime = "";
					newJob._endTime = "";
				}

				return newJob;
			});
			this.validateSection(
				"positions",
				newJobs.length > 0 && newJobs.filter(item => item._isValid === false).length === 0,
			);
			this.updateForm("positions", { Jobs: newJobs });
		}

		if (!isEditingJob && isJobEvent && prevStartDate !== jobStartDate) {
			// eslint-disable-next-line react/no-did-update-set-state
			this.setState({ positionStartDate: jobStartDate });
		}

		const { params, location } = this.props;

		const isNewJob =
			!params?.jobId &&
			!location.query?.jobId &&
			!location.query?.requestId &&
			!location.query?.draftId;
		if (
			!isNewJob &&
			OnlyAuthorizedClientsAreAllowedToUseVehicles &&
			_clientId &&
			!loadingClients &&
			!loadingForm &&
			!positionsUpdated
		) {
			const selectedClient = clients.find(c => c.value === _clientId);
			const clientAuthorized = !!selectedClient?.AuthorizedToUseDepartmentVehicles;
			if (!clientAuthorized) {
				if (
					Jobs.some(
						j =>
							j.VehicleRequired &&
							j.VehicleTypes.length > 0 &&
							j.VehicleTypes.some(vt => vt.AuthorizationRequired),
					)
				) {
					const updatedPositions = Jobs?.map(item => ({
						...item,
						VehicleRequired: false,
						VehicleTypes: [],
					}));
					this.updateForm("positions", { Jobs: updatedPositions }, true);
					this.setState({ positionsUpdated: true });

					this.confirmationModal.openModal({
						title: lang.t("Client not authorized to use department vehicles"),
						message: lang.t(
							"This client is currently not authorized to use department vehicles_ Please review any positions that may be affected_",
						),
						confirmButton: lang.t("OK"),
						hideCancel: true,
						onConfirm: () => {},
					});
				}
			}
		}
	}

	componentWillUnmount() {
		document.removeEventListener("click", this.clickEventListener);
	}

	setIsClientEnforceV2NonRKPayInvoicing = value => {
		this.setState({ isClientEnforceV2NonRKPayInvoicing: value });
	};

	loadJobInvoiceOnlyOptions = async (jobInvoicedTypeId, clientId, details) => {
		const { lang } = global;
		const { clients } = this.state;

		try {
			if (!clientId || jobInvoicedTypeId !== JOB_INVOICED_TYPES.SCHEDULE_ONLY) {
				return;
			}

			this.setState({ loadingSchedulingOptions: true });

			const { data } = await JobService.getSchedulingOnlyOptions(clientId);

			if (isEmpty(data)) return;

			const {
				PaymentDetails: PaymentDetailsOptions,
				NotInvoicingInformation,
				PaymentMethod,
				SchedulingJobType,
				AdditionalInformation,
				ClientPaysForTheJob,
				ElectronicallyBilled,
				SchedulingBillingContactId,
			} = data;

			if (
				details &&
				(details.ClientPaysForTheJob !== ClientPaysForTheJob ||
					details.ElectronicallyBilled !== ElectronicallyBilled)
			) {
				return;
			}

			// Since isClientEnforceV2NonRKPayInvoicing is updated inside the same method that calls loadJobInvoiceOnlyOption,
			// so its value may be stale. Instead, determine V2 enforcement by checking the client from client list.
			//
			// If the client enforces V2 and their invoicing default mode is “schedule-only,”
			// force clientPaysForJob to false.
			const selectedClient = clients.find(c => c.value === clientId);
			if (selectedClient?.EnforceV2NonRKPayInvoicing) {
				this.updateForm(
					"paymentDetails",
					{
						SchedulingJobType,
						AdditionalInformation,
						ClientPaysForTheJob: false,
					},
					false,
				);
				return;
			}

			this.updateForm(
				"paymentDetails",
				{
					NotInvoicingInformation,
					SchedulingJobType,
					AdditionalInformation,
					ClientPaysForTheJob,
					ElectronicallyBilled,
					PaymentDetails: PaymentDetailsOptions,
					AdditionalPaymentMethod: PaymentMethod,
					ClientBillingContactId: SchedulingBillingContactId,
				},
				false,
			);
		} catch {
			utils.notify({
				type: "error",
				message: lang.t("Error loading Scheduling Options"),
				timeOut: 1500,
			});
		} finally {
			this.setState({ loadingSchedulingOptions: false });
		}
	};

	/**
	 * Handles changes to the client in this section and updates the HOC state with the latest value.
	 * Values in other form sections that are impacted by client changes are also updated.
	 * @param {Object} event An object with `value` and `label` properties returned by a `ReactSelect` element when the selected value has been changed
	 */
	onClientChange = event => {
		const { user } = this.props;
		const officerInvoicingV3EnabledForOrg = user.Features.some(f => f.toLowerCase().includes("officerinvoicingv3"));

		const {
			clients,
			form: { positions, paymentDetails },
		} = this.state;

		if (event?.value === paymentDetails._clientId) {
			return;
		}

		this.updateForm("generalInfo", {
			_clientId: event?.value || "",
			ProjectId: "",
			LocationId: "",
		});

		// Clear vehicle types in all jobs
		const updatedPositions = positions.Jobs.map(item => ({
			...item,
			VehicleRequired: false,
			VehicleTypes: [],
		}));

		this.updateForm("positions", { Jobs: updatedPositions }, true);
		// reset Payment Details section details pertaining to client changes
		// We need to update always ExcludeOfficerRate to false when the client changes
		// in case the new client is not enabled to exclude officer rates and the previous one was
		this.updateForm(
			"paymentDetails",
			{
				RequirePrepayment: false,
				ExcludeOfficerRate: false,
			},
			true,
		);

		if (event) {
			const _clientId = event.value;
			const rkpayClient = clients.find(item => item.value === _clientId);
			this.getContacts(_clientId); // Retrieves contacts for this client
			if (user.isLEA()) {
				this.getContacts(_clientId, undefined, true); // FE-1161: Retrieves agency contacts that can access this client (LEAs only)
			}

			this.getProjects(_clientId);
			this.loadJobInvoiceOnlyOptions(rkpayClient.JobInvoicedTypeId, _clientId);

			const notScheduling =
				user.isInvoicingV3() &&
				(rkpayClient.JobInvoicedTypeId === JOB_INVOICED_TYPES.OFFICER_INVOICING ||
					rkpayClient.JobInvoicedTypeId === JOB_INVOICED_TYPES.AGENCY_INVOICING)
					? true
					: null;

			const paymentDetailsForm = {
				IsRKPay: officerInvoicingV3EnabledForOrg ? false : rkpayClient.JobInvoicedTypeId === 1 || rkpayClient.JobInvoicedTypeId === null,
				OrganizationFee: rkpayClient.OrganizationFee || "0",
				JobInvoicedTypeId: rkpayClient.JobInvoicedTypeId,
				ClientPaysForTheJob: notScheduling,
				ElectronicallyBilled: notScheduling,
				ClientBillingContactId:
					rkpayClient.BillingContactId || rkpayClient.billingContactId || "",
			};

			this.updateForm(
				"paymentDetails",
				{
					...paymentDetailsForm,
					TransferPaymentsToAgency: rkpayClient.TransferOfficerPaymentsToAgency,
				},
				false,
			);
			this.validateSection("generalInfo", false);
		} else {
			this.resetClientContacts();

			// FE-1168: When the client is cleared, the list must also be cleared (for internal coords, reset to the user being the supervisor)
			if (user.isLEA()) {
				this.resetAgencyContactList();
			}

			this.setState({
				projects: [],
				locations: [],
			});

			this.validateSection("generalInfo", false);
		}
		this.updateLocationCoordinates(GOOGLE_MAP_SETTINGS.defaultCenter);
	};

	/**
	 * Retrieves a list of projects for the given client
	 * @param {Number} clientId The ID number for a client
	 */
	getProjects = clientId => {
		const { lang } = global;

		this.setState({
			loadingProjects: true,
			projects: [],
			locations: [],
		});

		ProjectService.getAll({ includeAll: false, clientId })
			.then(({ data: { ItemList } }) => {
				const items = ItemList.map(item => ({
					value: item.Id,
					label: item.Name,
				}));

				this.setState({
					loadingProjects: false,
					projects: items,
				});
			})
			.catch(() => {
				this.setState({ loadingProjects: false });
				utils.notify({
					type: "error",
					message: lang.t("Error loading project list"),
					timeOut: 1500,
				});
			});
	};

	/**
	 * Retrieves a list of locations for the given project
	 * @param {Number} projectId The ID number for a project
	 */
	getLocations = async projectId => {
		const { lang } = global;

		this.setState({
			loadingLocations: true,
			locations: [],
		});

		await LocationService.getAll({ projectId })
			.then(({ data }) => {
				const items = data.map(item => ({
					value: item.Id,
					label: item.Name,
					coordinates: { lat: item.Latitude, lng: item.Longitude },
					// We're having an issue computing the equality using a constant. This is horrible, but the only way it worked (life is thug)
					// ApprovedTypes: 10 -> Approved, 20 -> Denied, 30 -> pendind
					isDisabled: item.ApprovedType && item.ApprovedType === 30,
				}));

				const [firstLocation] = (items || []).filter(elm => !elm.isDisabled);

				const locationId =
					this.isInvoicingFirstEnabled && firstLocation?.value ? firstLocation.value : "";

				this.setState({
					loadingLocations: false,
					locations: items,
					LocationId: locationId,
				});
			})
			.catch(() => {
				this.setState({ loadingLocations: false });
				utils.notify({
					type: "error",
					message: lang.t("Error loading Locations"),
					timeOut: 1500,
				});
			});
	};

	/** Retrieves a list of clients that the current user can create a job for */
	getClients = () => {
		const { lang } = global;
		const { user } = this.props;

		this.setState({ loadingClients: true });
		ClientService.getAll({
			includeInactive: false,
			organizationId: user.Organization.Id,
			getDetails: true,
		})
			.then(({ data }) => {
				const items = data.map(item => ({
					value: item.Id,
					label: item.Name,
					billingContactId: item.BillingContactId,
					IsAgencyRKPayEnabled: item.IsAgencyRKPayEnabled,
					IsRKPay: item.IsRKPay,
					OrganizationFee: item.OrganizationFee,
					JobInvoicedTypeId: item.JobInvoicedTypeId,
					AuthorizedToUseDepartmentVehicles: item.AuthorizedToUseDepartmentVehicles,
					AllowExcludeOfficerRate: item.AllowExcludeOfficerRate,
					TransferOfficerPaymentsToAgency: item.TransferOfficerPaymentsToAgency,
					EnforceIncludeOfficerRate: item.EnforceIncludeOfficerRate,
					EnforceV2NonRKPayInvoicing: item.EnforceV2NonRKPayInvoicing,
				}));

				this.setState({ clients: items, loadingClients: false });
			})
			.catch(() => {
				this.setState({ clients: [], loadingClients: false });
				utils.notify({
					type: "error",
					message: lang.t("Error loading clients"),
					timeOut: 1500,
				});
			});
	};

	/**
	 * Listens for clicks so that the estimate options can be closed automatically if the user clicks outside of the container
	 * @param {Event} event The HTML event handled by this method
	 */
	clickEventListener = ({ target }) => {
		const { showAgencyV3Options } = this.state;
		if (target.closest("#send-job-estimate")) return;
		if (showAgencyV3Options && !target.closest("#agency-estimate-options")) {
			this.setState({ showAgencyV3Options: false });
		}
	};

	/**
	 * Determines whether or not the job estimate should stay in place when scrolling down the page
	 * @param {React.RefObject} estimateRef A React ref to the element that contains the job estimate
	 * @param {React.RefObject} sectionsRef A React ref to the element that contains the different job form sections
	 */
	shouldEstimateBeSticky = ({ current: estimate }, { current: sections }) => {
		const areRefsDefined = (estimate && sections) || false;
		const mapContainer = document.getElementsByClassName("form-map-container")[0];
		// eslint-disable-next-line no-unsafe-optional-chaining
		const meetsHeightReqs =
			(estimate?.clientHeight + mapContainer?.clientHeight < sections?.clientHeight &&
				estimate?.clientHeight < window.innerHeight) ||
			false;
		return window.innerWidth >= 992 && areRefsDefined && meetsHeightReqs;
	};

	// This function is used to open the refactored AddContactModal by setting showAddContactModal in our state as true.
	// This function is also passed as prop to GeneralInformation and PaymentDetails, where its used to open the modal.

	openQuickAddContactModal = type => {
		this.setState({
			showAddContactModal: true,
			addContactModalType: type,
		});
	};

	// onClose() Functionality here after closing ClientContact, AgencyContact and Billing contact in GeneralInformation and PaymentDetails page.

	closeQuickAddContactModal = () => {
		const {
			form: {
				generalInfo: { _clientId, _includeCoordinators },
			},
			addContactModalType,
		} = this.state;
		this.setState({
			showAddContactModal: false,
			addContactModalType: "",
		});
		if (addContactModalType === "agency") {
			this.getContacts(undefined, _includeCoordinators);
		} else {
			this.getContacts(_clientId);
		}
	};

	militaryTimeMask = value => {
		const chars = value.split("");
		const hours = [/[0-2]/, chars[0] === "2" ? /[0-3]/ : /[0-9]/];
		const minutes = [/[0-5]/, /[0-9]/];
		return hours.concat(":").concat(minutes);
	};

	/**
	 * Retrieves a list of contacts depending on the parameters provided. If the parameter `_clientId` is defined, contacts for
	 * the given client will be retrieved. Otherwise, a list of contacts for the current user's organization will be retrieved taking
	 * the other function parameters into account.
	 * @param {String|Number} _clientId The ID number for a client to retrieve contacts for
	 * @param {Boolean} includeCoordinators Whether or not to include external coordinators in the list of contacts retrieved.
	 * _Does not apply to client contacts._
	 * @param {Boolean} canSupervise Whether or not to include LEA coordinators in the list of contacts retrieved. _Does not apply to client contacts._
	 */
	getContacts = (
		_clientId = undefined,
		includeCoordinators = false,
		canSupervise = undefined,
	) => {
		const {
			user: { Organization },
		} = this.props;
		// This property name is misleading: For agency contacts, this is the user's organization ID
		const clientId = _clientId && !canSupervise ? _clientId : Organization.Id;

		const params = {
			clientId,
			includeCoordinators,
			canSupervise,
			isOrganization: !_clientId || (_clientId && canSupervise),
			internalCoordClientId: _clientId,
		};
		ContactService.getAll(params)
			.then(({ data: { ItemList } }) => {
				const contacts = ItemList.map(({ Id: value, ContactName: label }) => ({
					value,
					label,
				}));
				if (_clientId && !canSupervise) this.setState({ clientContacts: contacts });
				else this.setState({ agencyContacts: contacts });
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: "Error loading contacts",
					timeOut: 1500,
				});
			});
	};

	/** Resets the list of contacts for a client. Currently only called when the selected client has been cleared. */
	resetClientContacts = () => {
		// when resetting the client contacts we also want reset the client billing contact ID
		this.setState(prevState => ({
			clientContacts: [],
			form: {
				...prevState.form,
				paymentDetails: {
					...prevState.form.paymentDetails,
					ClientBillingContactId: "",
				},
			},
		}));
	};

	/** Resets the list of contacts for the current user's organization
	 *
	 * _THIS METHOD IS ONLY TO BE USED WHEN THE USER IS AN LEA_ */
	resetAgencyContactList = () => {
		const { user } = this.props;
		const { ContactId, LastName, FirstName } = user;
		this.setState(prevState => ({
			agencyContacts: [{ value: ContactId, label: `${LastName}, ${FirstName}` }],
			form: {
				...prevState.form,
				generalInfo: {
					...prevState.form.generalInfo,
					SupervisorContactId: user.isInternalCoordinator ? ContactId : "",
					SecondarySupervisorModel: [],
				},
			},
		}));
	};

	/**
	 * Retrieves job details for a given job from the API
	 * @param {String|Number} jobId The ID number of the job to retrive details for
	 * @param {Boolean} editingJob Indicates whether the user is editing or duplicating a job. Defaults to `false`.
	 */
	loadJobDetails = async (jobId, editingJob = false) => {
		this.setState({ loadingForm: true });
		const {
			user,
			user: { Organization: IsPayCodeMandatory },
		} = this.props;
		const {
			form: {
				generalInfo: { JobEventRecurrenceRule: defaultRecurrenceObject },
			},
		} = this.state;
		const { HOURLY, PAY_CODE } = PAY_RATE_TYPE;
		const isInvoicingV3 = user.Features.some(f => f.toLowerCase() === "invoicingv3");
		let _positionWithPayCodeExist = false;
		let _applyPTAEOcode = false;

		const rawOfficerRanks = await OfficerService.getRanks();
		const officerRanks = rawOfficerRanks.data.map(({ Value, Text, Weight }) => ({
			value: parseInt(Value, 10),
			label: Text,
			weight: Weight,
		}));

		const promises = [JobService.getById(jobId)];

		if (this.isInvoicingDetailsComponentEnabled || this.jobDescriptionAttachments) {
			promises.push(JobService.getAdditionalInformationById(jobId));
		}

		Promise.all(promises)
			.then(async ([jobEventDataResponse, additionalInformationDataResponse]) => {
				const { data } = jobEventDataResponse;
				const { data: additionalInformation } = additionalInformationDataResponse || {
					data: null,
				};
				const { TimeZoneId, StartDateTime, EndDateTime, JobEventRecurrenceRule } = data;
				const userOwnsJob = user.Organization.Id === data.AgencyId;

				// Getting location data to prevent populating the location dropdown with disabled locations
				// await this.getLocations(data.ProjectId);
				// const isLocationDisabled = this.state.locations.find((loc) => loc.value == data.LocationId).isDisabled;

				// Build the information for all sections based on data received
				/*
					Adding a Z at the end of StartDateTime and EndDateTime because API dates are
					UTC but do not indicate this in their format.
					Desktop Safari & IE don't support date inputs, so we have to show it in US format
				*/
				const dateLocale = utils.isDesktopSafari || utils.isIE ? "en-US" : undefined;
				// TODO: Remove line below once unicode 'en-CA' fix confirmed
				// const hour12time = (user.UserPreferences !== 'useMilitaryTime');
				const hour12time = false;
				const generalInfo = {
					_expanded: !this.isInvoicingFirstEnabled,
					_clientId: data.ClientId,
					_startDate: utils.formatDate(
						new Date(`${StartDateTime}Z`),
						dateLocale,
						TimeZoneId,
					),
					_startTime: utils.formatTime(
						new Date(`${StartDateTime}Z`),
						hour12time,
						TimeZoneId,
					),
					_endTime: utils.formatTime(new Date(`${EndDateTime}Z`), hour12time, TimeZoneId),
					_isRecurring: JobEventRecurrenceRule !== null,
					_includeCoordinators: data.IsExternalSupervisor,
					_flexJob: data.Jobs[0].FlexJob || false,
					_flexJobMinHours: data.Jobs[0].FlexJobMinHours || "",
					Name: data.Name,
					ProjectId: data.ProjectId,
					LocationId: data.LocationId,
					JobEventTypeId: data.JobEventTypeId,
					JobEventTags: data.JobEventTags,
					Details: data.Details,
					ShowClientContactToOfficer: data.ShowClientContactToOfficer,
					ClientSupervisorContactId: data.ClientSupervisorContactId,
					SupervisorContactId: data.SupervisorContactId,
					SecondarySupervisorModel: [],
				};

				if (hour12time) {
					generalInfo._startTime = utils.convertTime12to24(generalInfo._startTime);
					generalInfo._endTime = utils.convertTime12to24(generalInfo._endTime);
				}

				if (data.SecondarySupervisorModel && data.SecondarySupervisorModel.length > 0) {
					generalInfo.SecondarySupervisorModel = data.SecondarySupervisorModel.map(
						item => ({
							SecondaryAgencySupervisorId: item.SecondaryAgencySupervisorId,
							SendNotification: item.SendNotification,
						}),
					);
				}

				// Format any attachments from additionalInformation
				if (
					this.jobDescriptionAttachments &&
					additionalInformation?.Attachments &&
					additionalInformation.Attachments.length > 0
				) {
					generalInfo.JobEventAttachments = additionalInformation.Attachments.map(
						attachment => ({
							id: attachment.AttachmentId.toString(),
							name: attachment.AttachmentName,
							url: attachment.Url,
							existingFile: true,
						}),
					);
				}

				if (JobEventRecurrenceRule !== null) {
					const { StartsOn, EndsOn, RepeatsOn, CustomDates } = JobEventRecurrenceRule;
					generalInfo.JobEventRecurrenceRule = {
						RepeatType: JobEventRecurrenceRule.RepeatType,
						RepeatsOn: RepeatsOn
							? RepeatsOn.split(",").map(day => day.toLowerCase())
							: [],
						WeekFrequency: JobEventRecurrenceRule.WeekFrequency || "1",
						StartsOn: StartsOn
							? utils.formatDate(new Date(`${StartsOn}Z`), "en-US", TimeZoneId)
							: "",
						EndType: JobEventRecurrenceRule.EndType,
						EndsAfterOccurrence: JobEventRecurrenceRule.EndsAfterOccurrence || "",
						EndsOn:
							EndsOn && JobEventRecurrenceRule.EndType !== "OCCURRENCE"
								? utils.formatDate(new Date(`${EndsOn}Z`), dateLocale, TimeZoneId)
								: "",
						CustomDates: CustomDates
							? CustomDates.map(date =>
									utils.formatDate(new Date(`${date}Z`), undefined, TimeZoneId),
								)
							: [],
					};
				} else {
					// Create an copy of the default recurrence settings without keeping a reference to it
					// We will set the start date to match the job start date, though
					// In case the user wants to add recurrence later, this should be present
					generalInfo.JobEventRecurrenceRule = {
						...defaultRecurrenceObject,
						StartsOn: utils.formatDate(
							new Date(`${StartDateTime}Z`),
							"en-US",
							TimeZoneId,
						),
					};
				}
				const positionGroupMap = {};
				const jobCreationDate = new Date(`${data.CreateDateUTC}Z`).getTime();
				const Jobs = data.Jobs.map((job, index) => {
					// Create a map of all existing position group IDs so that we can map them to new values
					// If editing a job with supervisor positions but no position group IDs, create them for supervisors
					if (editingJob && job.PositionGroupId && !positionGroupMap[job.Id]) {
						positionGroupMap[job.Id] = `positionGroup-${jobCreationDate + index * 100}`;
					} else if (
						(job.PositionGroupId && !positionGroupMap[job.PositionGroupId || job.Id]) ||
						(!job.PositionGroupId && job.SupervisorPosition === true)
					) {
						// If duplicating, create a map of all existing position group IDs so that we can map them to new values
						positionGroupMap[job.PositionGroupId || job.Id] =
							`positionGroup-${jobCreationDate + index * 100}`;
					}

					const _rate = !job.PayCodeId ? job.Rate : "";
					const getPositionRate = () => {
						if (utils.isPayRateValid(_rate)) {
							return HOURLY;
						}
						if (job.PayCodeId || IsPayCodeMandatory) {
							return PAY_CODE;
						}
						return HOURLY;
					};

					const position = {
						_isValid: true,
						_needsMultipleOfficers: job.OfficersNeeded > 1,
						_isRovingPatrol: job.RovingPatrol !== null,
						_assetsRequired: job.RequiredJurisdictionAssets.length > 0,
						_positionStartDate: utils.formatDate(
							new Date(`${job.StartDateTime}Z`),
							dateLocale,
							TimeZoneId,
						),
						_startTime: utils.formatTime(
							new Date(`${job.StartDateTime}Z`),
							hour12time,
							TimeZoneId,
						),
						_endTime: utils.formatTime(
							new Date(`${job.EndDateTime}Z`),
							hour12time,
							TimeZoneId,
						),
						_certificationRequired: job.JobCertifications.length !== 0,
						_hasAssignedOfficers: editingJob ? job.AssignedOfficers.length > 0 : false,
						_initialRate: editingJob ? job.Rate.toString() : "0",
						_isRankRequired: job.RequestedOfficerRankId !== null,
						_isMaxRankRequired: job.MaxRequestedOfficerRankId !== null,
						_hasRankRestriction:
							job.RequestedOfficerRankId !== null ||
							job.MaxRequestedOfficerRankId !== null,
						Title: job.Title,
						OfficersNeeded: job.OfficersNeeded,
						Rate: _rate,
						Details: job.Details,
						SupervisorPosition: job.SupervisorPosition,
						SortOrder: job.SortOrder,
						PositionGroupId:
							(editingJob
								? job.PositionGroupId
								: positionGroupMap[job.PositionGroupId]) ||
							positionGroupMap[job.Id],
						RequestedOfficerRankId: job.RequestedOfficerRankId || "",
						RequestedOfficerRank: job.RequestedOfficerRankId
							? officerRanks.find(item => item.value === job.RequestedOfficerRankId)
									.label
							: null,
						RequestedOfficerRankWeight: job.RequestedOfficerRankId
							? officerRanks.find(item => item.value === job.RequestedOfficerRankId)
									.weight
							: null,
						MaxRequestedOfficerRankId: job.MaxRequestedOfficerRankId || "",
						MaxRequestedOfficerRank: job.MaxRequestedOfficerRankId
							? officerRanks.find(
									item => item.value === job.MaxRequestedOfficerRankId,
								).label
							: null,
						MaxRequestedOfficerRankWeight: job.MaxRequestedOfficerRankId
							? officerRanks.find(
									item => item.value === job.MaxRequestedOfficerRankId,
								).weight
							: null,
						OfficerRankRequired: job.OfficerRankRequired || false,
						RovingPatrol: job.RovingPatrol || "",
						RequiredJurisdictionAssets: job.RequiredJurisdictionAssets,
						VehicleRequired: job.VehicleRequired,
						VehicleTypes: job.VehicleTypes,
						JobCertifications:
							job.JobCertifications.map(
								({ OfficerCertificationTypeId, OfficerCertificationTypeName }) => ({
									value: OfficerCertificationTypeId,
									label: OfficerCertificationTypeName,
								}),
							) || [],
						DressTypeId: job.DressTypeId || "",
						DressTypeNote: job.DressTypeNote || "",
						OfficerRequirements: job.OfficerRequirements || "",
						FlexJob: job.FlexJob || false,
						FlexJobMinHours: job.FlexJobMinHours || "",
						PayCodeId: job.PayCodeId || null,
						PTAEOCodeId: job.PTAEOCodeId || null,
						positionRate: getPositionRate(),
						RecurrenceRuleId: job.RecurrenceRuleId || null,
					};

					if (job.PayCodeId) _positionWithPayCodeExist = true;
					if (job.PTAEOCodeId != null && job.PTAEOCodeId !== "") _applyPTAEOcode = true;
					if (editingJob) position.Id = job.Id;
					return position;
				});
				// After we map the objects from the Jobs array, sort them first by SortOrder
				// For jobs created prior to implementing position groups (all SortOrder values are 0), sort by supervisory positions
				Jobs.sort((a, b) => {
					const aPositionGroup = a.PositionGroupId
						? parseInt(a.PositionGroupId.replace("positionGroup-", ""), 10)
						: 0;
					const bPositionGroup = b.PositionGroupId
						? parseInt(b.PositionGroupId.replace("positionGroup-", ""), 10)
						: 0;
					// In order of priority, sort by PositionGroupId, then supervisor status
					return (
						aPositionGroup - bPositionGroup ||
						b.SupervisorPosition - a.SupervisorPosition
					);
				});

				const positions = { _expanded: false, Jobs };

				let clientPaysForTheJob = additionalInformation?.ClientPaysForTheJob ?? null;
				let electronicallyBilled = additionalInformation?.ElectronicallyBilled ?? null;

				if (
					this.isInvoicingDetailsComponentEnabled &&
					(data.JobInvoicedTypeId === JOB_INVOICED_TYPES.OFFICER_INVOICING ||
						data.JobInvoicedTypeId === JOB_INVOICED_TYPES.AGENCY_INVOICING) &&
					clientPaysForTheJob === null &&
					electronicallyBilled === null &&
					isInvoicingV3
				) {
					clientPaysForTheJob = true;
					electronicallyBilled = true;
				}

				const paymentDetails = {
					_expanded: this.isInvoicingFirstEnabled,
					IsRKPay: data.IsRKPay,
					IsScheduling: data.JobInvoicedTypeId === 3,
					JobInvoicedTypeId: data.JobInvoicedTypeId ?? (data.IsRKPay ? 1 : 2),
					RequirePrepayment: data.RequirePrepayment,
					OrganizationFee: data.OrganizationFee,
					ClientBillingContactId: data.ClientBillingContactId,
					WaiveJurisdictionFees: data.WaiveJurisdictionFees || false,
					TransferPaymentsToAgency: data.TransferPaymentsToAgency || false,
					PaymentMethod: data.PaymentMethod,
					ClientPaysForTheJob: clientPaysForTheJob,
					ElectronicallyBilled: electronicallyBilled,
					TermsAndConditionsAcknowledge:
						additionalInformation?.TermsAndConditionsAcknowledge ?? false,
					ExcludeOfficerRate: additionalInformation?.ExcludeOfficerRate ?? false,
					SchedulingJobType: additionalInformation?.SchedulingJobType ?? null,
					AdditionalInformation: additionalInformation?.AdditionalInformation ?? "",
					InvoicingType: additionalInformation?.InvoicingType ?? null,
					PaymentDetails: additionalInformation?.PaymentDetails ?? "",
					AdditionalPaymentMethod: additionalInformation?.PaymentMethod ?? null,
					NotInvoicingInformation: additionalInformation?.NotInvoicingInformation ?? "",
				};

				if (
					this.isInvoicingDetailsComponentEnabled &&
					isInvoicingV3 &&
					!editingJob &&
					!this.isDefaultClientValuesCloningJobEnabled
				) {
					const { data: client } = await ClientService.getById(data.ClientId);

					if (
						(paymentDetails.JobInvoicedTypeId ===
							JOB_INVOICED_TYPES.OFFICER_INVOICING ||
							paymentDetails.JobInvoicedTypeId ===
								JOB_INVOICED_TYPES.AGENCY_INVOICING) &&
						(client.JobInvoicedTypeId === JOB_INVOICED_TYPES.OFFICER_INVOICING ||
							client.JobInvoicedTypeId === JOB_INVOICED_TYPES.AGENCY_INVOICING)
					) {
						paymentDetails.ClientPaysForTheJob = true;
						paymentDetails.ElectronicallyBilled = true;
						paymentDetails.ClientBillingContactId = client.BillingContactId;

						paymentDetails.NotInvoicingInformation = "";
						paymentDetails.SchedulingJobType = null;
						paymentDetails.AdditionalInformation = "";
						paymentDetails.PaymentDetails = "";
						paymentDetails.AdditionalPaymentMethod = null;
					} else if (
						paymentDetails.JobInvoicedTypeId === JOB_INVOICED_TYPES.SCHEDULE_ONLY &&
						client.JobInvoicedTypeId === JOB_INVOICED_TYPES.SCHEDULE_ONLY
					) {
						const { data: schedulingOnlyOptions } =
							await JobService.getSchedulingOnlyOptions(data.ClientId);

						if (!isEmpty(schedulingOnlyOptions)) {
							const {
								PaymentDetails: PaymentDetailsOptions,
								NotInvoicingInformation,
								PaymentMethod,
								SchedulingJobType,
								AdditionalInformation,
								ClientPaysForTheJob,
								ElectronicallyBilled,
								SchedulingBillingContactId,
							} = schedulingOnlyOptions;

							paymentDetails.JobInvoicedTypeId = JOB_INVOICED_TYPES.SCHEDULE_ONLY;
							paymentDetails.ClientBillingContactId = SchedulingBillingContactId;
							paymentDetails.NotInvoicingInformation = NotInvoicingInformation;
							paymentDetails.SchedulingJobType = SchedulingJobType;
							paymentDetails.AdditionalInformation = AdditionalInformation;
							paymentDetails.ClientPaysForTheJob = ClientPaysForTheJob;
							paymentDetails.ElectronicallyBilled = ElectronicallyBilled;
							paymentDetails.PaymentDetails = PaymentDetailsOptions;
							paymentDetails.AdditionalPaymentMethod = PaymentMethod;
						}

						if (paymentDetails.JobInvoicedTypeId === null) {
							paymentDetails.JobInvoicedTypeId = client.JobInvoicedTypeId;
						}
					}
				}

				// When reading officer fulfillment info, replace null values for ExpiresBefore with 0
				const officerFulfillment = {
					_expanded: false,
					_usingRestrictions:
						data.ExcludedJurisdictions.length > 0 ||
						data.RequiredJurisdictions.length > 0,
					ExcludedJurisdictions: data.ExcludedJurisdictions.map(item => ({
						...item,
						ExpiresBefore: item.ExpiresBefore || 0,
						Visibility: "hide",
					})),
					RequiredJurisdictions: data.RequiredJurisdictions.map(item => ({
						...item,
						ExpiresBefore: item.ExpiresBefore || 0,
						Visibility: "show",
					})),
				};

				// Update map coordinates if they are available
				let locationCoordinates = { ...GOOGLE_MAP_SETTINGS.defaultCenter };
				if (
					data.LocationLatitude instanceof Number &&
					data.LocationLongitude instanceof Number
				) {
					locationCoordinates = {
						lat: data.LocationLatitude,
						lng: data.LocationLongitude,
					};
				}

				// Preserve certain Ids and properties if editing an existing job
				const { jobEditingProperties: oldEditingProperties } = this.state;
				const jobEditingProperties = editingJob
					? {
							Id: data.Id,
							Deleted: data.Deleted,
							JobEventRecurrenceRuleId: data.JobEventRecurrenceRuleId,
							UpdateOnlyChanged: true,
							updateAllUpcoming: undefined,
							_prevJobType: data.JobEventTypeId,
							_userOwnsJob: userOwnsJob,
							_isExternalSupervisor: data.IsExternalSupervisor,
						}
					: oldEditingProperties;

				// Building invoice estimate details
				const invoiceEstimate = {
					RequireClientInvoiceEstimateApproval:
						data.RequireClientInvoiceEstimateApproval || false,
					SendClientInvoiceEstimate: data.JobEventInvoicEstimateApproval !== null,
					ClientInvoiceEstimateContactId:
						data.JobEventInvoicEstimateApproval?.ClientContactId || "",
					ClientInvoiceEstimateJurisdictionId:
						data.JobEventInvoicEstimateApproval?.JurisdictionId ||
						user.Organization.JurisdictionId,
				};

				// Update state, marking all sections as valid (we know this because the job has already been created once)
				// Update estimateButtonState as well since we know the form is valid
				this.setState(
					prevState => ({
						createDateUTC: data.CreateDateUTC,
						pageTitle: editingJob ? "Edit Job / Estimate" : "Duplicate Job / Estimate",
						estimatePostOption: data.Posted
							? "automatic"
							: prevState.estimatePostOption,
						estimateJurisdictionName:
							data.JobEventInvoicEstimateApproval?.JurisdictionName ||
							prevState.estimateJurisdictionName,
						estimateButtonState: "",
						form: {
							...prevState.form,
							generalInfo,
							positions,
							paymentDetails,
							officerFulfillment,
						},
						isGeneralInfoValid: true,
						isPositionsValid: true,
						isPaymentDetailsValid: true,
						isOfficerFulfillmentValid: true,
						originalSendEstimateSettings: {
							RequireClientInvoiceEstimateApproval:
								invoiceEstimate.RequireClientInvoiceEstimateApproval,
							SendClientInvoiceEstimate: invoiceEstimate.SendClientInvoiceEstimate,
						},
						invoiceEstimate,
						locationCoordinates,
						jobEditingProperties,
						isJobPaidFor: editingJob
							? data.JobEventInvoicEstimateApproval?.IsApproved &&
								data.RequirePrepayment
							: false,
						isJobCompleted: data.StatusId === 3,
						positionStartDate: utils.formatDate(
							new Date(`${EndDateTime}Z`),
							dateLocale,
							TimeZoneId,
						),
						positionEndDate:
							new Date(`${EndDateTime}Z`).getTime() -
								new Date(`${StartDateTime}Z`).getTime() >=
							86400
								? utils.formatDate(
										new Date(`${EndDateTime}Z`),
										"en-US",
										TimeZoneId,
										"2-digit",
									)
								: "",
						positionWithPayCodeExist: _positionWithPayCodeExist,
						applyPTAEOcode: _applyPTAEOcode,
					}),
					() => {
						// Fetch manual estimates for the given client if the user has invoicing v3
						this.getContacts(
							data.ClientId,
							((user.isLEA() && user.IsStaffAdmin) || !user.isLEA()) &&
								data.IsExternalSupervisor,
							true,
						);
						this.loadJobEstimate(jobId);
						this.getPayCodes();
						this.getPTAEOCodes();
					},
				);
			})
			.catch(() => {
				this.setState({ loadingForm: false });
				utils.notify({
					type: "error",
					message: "Error loading job details",
					timeOut: 1500,
				});
			});
	};

	/**
	 * Retrieves estimate details for a given job from the API
	 * @param {String|Number} jobId The ID number for the job to retrieve estimate details for
	 */
	loadJobEstimate = jobId => {
		this.setState({ loadingEstimate: true });
		JobService.getJobEstimateById(jobId)
			.then(({ data }) => {
				// If the jobEvent doesn't have an estimate saved, then re-calculate it
				if (data) {
					this.setState(prevState => ({
						loadingEstimate: false,
						estimateInfo: {
							...prevState.estimateInfo,
							...data.InvoiceEstimate,
						},
					}));
				} else {
					this.getJobEstimate();
				}
			})
			.catch(error => {
				if (!axios.isCancel(error)) {
					this.setState({ loadingEstimate: false, estimateInfo: {} });
					utils.notify({
						type: "error",
						message: "Error loading job estimate",
						timeOut: 1500,
					});
				}
			});
	};

	/** Sends details from the current state of the job form to the API in order to calculate an estimate
	 * @param {Object} jursidiction The jurisdiction to consider when calculating the estimate
	 * @param {Function} callback An optional function to call after an estimate has been calculated.
	 * If an error occurred during estimate calculation, `{ error : true }` will be passed as a parameter to the callback function.
	 */
	getJobEstimate = (jurisdiction, callback) => {
		const {
			form: { generalInfo, positions, paymentDetails, officerFulfillment },
			invoiceEstimate,
			isGeneralInfoValid,
			isPositionsValid,
			isPaymentDetailsValid,
			isOfficerFulfillmentValid,
			jobRequestProperties,
		} = this.state;

		// Update as of FE-56: we want to avoid calling the estimate API until the user
		// has entered at least one position.
		const { _clientId, LocationId, JobEventTypeId, _startDate, _startTime, _endTime } =
			generalInfo;
		const { Jobs } = positions;

		// If LocationId is not present do not proceed to call API since Avalara is dependent on location for estimate calculation
		if (LocationId === "") return;
		// If there are no jobs, or if any jobs are invalid do not call the API;
		if (Jobs.length === 0 || Jobs.filter(job => !job._isValid).length > 0) return;
		// If the job type is not event and no start date, start time, or end time are provided, do not call the API
		if (JobEventTypeId !== 6 && (_startDate === "" || _startTime === "" || _endTime === ""))
			return;
		// Do not call if no time range defined
		if (JobEventTypeId !== 6 && _startTime === _endTime) return;
		// On IE11, if the start or end time has not been completely filled out (including AM/PM), do not call the API
		if (
			(utils.isIE || utils.isDesktopSafari) &&
			JobEventTypeId !== 6 &&
			(_startTime.replace(/_/g, "").length < 5 || _endTime.replace(/_/g, "").length < 5)
		)
			return;
		/* RKP-1778: If a coordinator is creating a new job from a client request, don't call API until
		they have provided a client and location */
		if (Object.keys(jobRequestProperties).length > 0 && _clientId === "") return;

		let jurisdictionId;

		// If jurisdiction is null that means empty value was sent (make request without jurisdictionId)
		// If jurisdiction not present or undefined, we are not trying to change jurisdictionId and
		// take the current value to make the request
		if (jurisdiction) {
			jurisdictionId = jurisdiction.value;
		} else if (jurisdiction === null) {
			jurisdictionId = undefined;
		} else {
			jurisdictionId = invoiceEstimate.ClientInvoiceEstimateJurisdictionId;
		}

		if (invoiceEstimate.ClientInvoiceEstimateJurisdictionId !== jurisdictionId) {
			this.setState(prevState => ({
				invoiceEstimate: {
					...prevState.invoiceEstimate,
					ClientInvoiceEstimateJurisdictionId: jurisdictionId,
				},
			}));
		}

		/* Because form state is carried locally now, the object is so deep that just spreading each section
		 * does not remove references to state. We use cloneDeep to prevent unwanted state updates.
		 * TODO Sync and update the state of the form properly to avoid doing this.
		 */
		const formData = cloneDeep({
			...generalInfo,
			...positions,
			...paymentDetails,
			...officerFulfillment,
		});

		const formToSend = this.prepareFormData(formData);
		let estimateButtonState = "disabled";
		if (
			isGeneralInfoValid &&
			isPositionsValid &&
			isPaymentDetailsValid &&
			isOfficerFulfillmentValid
		) {
			estimateButtonState = "";
		}

		// Verify if the is there any invalid date and avoid a call to the API
		if (formToSend.StartDateTime === "" || formToSend.EndDateTime === "") {
			return;
		}
		// If there is a request already running, abort it and start a new one
		if (cancelJobEstimate !== undefined) {
			cancelJobEstimate();
		}

		/**
		 * Remove job event attachments from the form data
		 * since they are not needed for the estimate calculation.
		 */
		if (this.jobDescriptionAttachments) delete formToSend.JobEventAttachments;

		JobService.getJobEstimateByData({
			queryParams: { jurisdictionId },
			data: formToSend,
			getCancelToken: c => {
				cancelJobEstimate = c;
			},
		})
			.then(({ data }) => {
				cancelJobEstimate = undefined;
				this.setState(
					prevState => ({
						estimateButtonState,
						loadingEstimate: false,
						estimateInfo: {
							...prevState.estimateInfo,
							...data,
						},
					}),
					() => {
						if (callback) callback();
					},
				);
			})
			.catch(error => {
				if (!axios.isCancel(error)) {
					this.setState({ loadingEstimate: false, estimateInfo: {} }, () => {
						if (callback) callback({ error: true });
					});
				}
			});
	};

	/**
	 * Retrieves a previously saved job draft and sets the form to the exact state it was in at the time of being saved
	 * @param {String|Number} draftId The ID number for a job draft
	 */
	loadJobDraft = draftId => {
		this.setState({ loadingForm: true });
		JobEventDraftsService.getJobDraft(draftId)
			.then(({ data }) => {
				const { DraftData } = data;
				const {
					form: {
						generalInfo: { _clientId: draftClientId },
					},
				} = DraftData;
				// If a clientId has been selected already, there will be more to load
				// in the General Information section
				this.setState(prevState => {
					const state = {
						...prevState,
						...DraftData,
						loadingForm: draftClientId !== "",
					};
					state.form.positions.Jobs = state.form.positions.Jobs.map(job => ({
						...job,
						JobCertifications: job.JobCertifications || [],
						_certificationRequired: (job.JobCertifications || []).length !== 0,
					}));
					return state;
				});
			})
			.catch(() => {
				this.setState({ loadingForm: false });
				utils.notify({
					type: "error",
					message: "Unable to load job draft",
					timeOut: 1500,
				});
			});
	};

	finishLoadingForm = () => this.setState({ loadingForm: false });

	/**
	 * Retrieves a client's job request from the Marketplace page and sets the provided values into the job form.
	 * @param {String|Number} requestId The ID number for a job request
	 */
	loadJobRequest = requestId => {
		this.setState({ loadingForm: true });
		ClientJobRequestService.getJobRequestDetails(requestId)
			.then(({ data }) => {
				const { StartDateTime, EndDateTime, Recurrence } = data;
				const {
					user: { TimeZoneId, ...user },
				} = this.props;
				const isEvent = data.JobEventTypeId === FORM_JOB_TYPES.EVENT.value;
				const officerInvoicingV3EnabledForOrg = user.Features.some(f => f.toLowerCase().includes("officerinvoicingv3"));

				/*
				- NOT adding a Z at the end of StartDateTime and EndDateTime because API dates are local to client's timezone.
				- Desktop Safari & IE don't support date inputs, so we have to show it in US format
				*/
				const dateLocale = utils.isDesktopSafari || utils.isIE ? "en-US" : undefined;
				const hour12time = user.UserPreferences !== "useMilitaryTime";
				const generalInfo = {
					_startDate: utils.formatDate(new Date(StartDateTime), dateLocale, TimeZoneId),
					_isRecurring: !!Recurrence,
					JobEventTypeId: data.JobEventTypeId,
					Details: data.JobDetails,
				};

				// If the request is not for an Event, set start/end times in General Information
				if (isEvent) {
					generalInfo._startTime = utils.formatTime(
						new Date(StartDateTime),
						hour12time,
						TimeZoneId,
					);
					generalInfo._endTime = utils.formatTime(
						new Date(EndDateTime),
						hour12time,
						TimeZoneId,
					);
				}

				if (Recurrence) {
					const { EndsOn, RepeatsOn, CustomDates } = Recurrence;
					generalInfo.JobEventRecurrenceRule = {
						RepeatType: Recurrence.RepeatType,
						RepeatsOn: RepeatsOn
							? RepeatsOn.split(",").map(day => day.toLowerCase())
							: [],
						WeekFrequency: Recurrence.WeekFrequency || "1",
						StartsOn: utils.formatDate(new Date(StartDateTime), dateLocale, TimeZoneId),
						EndType: "DATE",
						EndsAfterOccurrence: Recurrence.EndsAfterOccurrance || "",
						EndsOn: utils.formatDate(new Date(EndsOn), dateLocale, TimeZoneId),
						CustomDates: CustomDates
							? CustomDates.map(date =>
									utils.formatDate(new Date(`${date}Z`), undefined, TimeZoneId),
								)
							: [],
					};
				}

				// Create a single empty position for the job
				const positions = {
					Jobs: [
						{
							...emptyPosition,
							_startTime: isEvent
								? utils.formatTime(new Date(StartDateTime), hour12time, TimeZoneId)
								: "",
							_endTime: isEvent
								? utils.formatTime(new Date(EndDateTime), hour12time, TimeZoneId)
								: "",
							Rate: data.Rate,
						},
					],
				};

				// Marketplace jobs *SHOULD* be prepay/RKPay (if I'm not mistaken)
				const paymentDetails = {
					IsRKPay: !officerInvoicingV3EnabledForOrg,
					RequirePrepayment: !officerInvoicingV3EnabledForOrg,
					ClientBillingContactId: "",
				};

				// Building invoice estimate details
				const invoiceEstimate = {
					RequireClientInvoiceEstimateApproval: true,
					SendClientInvoiceEstimate: true,
					ClientInvoiceEstimateContactId: "",
					ClientInvoiceEstimateJurisdtionId: user.Organization.JurisdictionId || null,
				};

				this.setState(prevState => ({
					loadingForm: false,
					form: {
						...prevState.form,
						generalInfo: {
							...prevState.form.generalInfo,
							...generalInfo,
						},
						positions: {
							...prevState.form.positions,
							...positions,
						},
						paymentDetails: {
							...prevState.form.paymentDetails,
							...paymentDetails,
						},
					},
					invoiceEstimate: {
						...prevState.invoiceEstimate,
						...invoiceEstimate,
					},
					jobRequestProperties: {
						requestId,
						showClientModal: true,
						prefillLocation: true,
						prefillUser: true,
						clientName: data.OrganizationName,
						locationTypeId: data.LocationTypeId,
						locationTypeName: data.LocationTypeName,
						locationName: data.LocationName,
						streetAddress: data.StreetAddress,
						city: data.City,
						stateId: data.StateId,
						zipCode: data.ZipCode,
						userEmail: data.UserEmail,
						userFirstName: data.UserFirstName,
						userLastName: data.UserLastName,
						userPhone: data.UserMobile,
					},
				}));
			})
			.catch(() => {
				this.setState({ loadingForm: false });
				utils.notify({
					type: "error",
					message: "Error loading job request details",
					timeOut: 1500,
				});
			});
	};

	/**
	 * Updates the coordinates of the Google Maps marker for the job location
	 * @param {Object} newCoordinates An object containing updated `lat` and `lng` values to display a location on the map
	 */
	updateLocationCoordinates = newCoordinates => {
		const { locationCoordinates } = this.state;
		if (
			locationCoordinates.lat !== newCoordinates.lat ||
			locationCoordinates.lng !== newCoordinates.lng
		) {
			this.setState({ locationCoordinates: newCoordinates });
		}
	};

	/**
	 *  Updates the jurisdiction used to calculate the job estimate. Updating jurisdiction selection automatically calls {@link getJobEstimate}.
	 * @param {Object} event An object with `value` and `label` properties returned by a `ReactSelect` element when the selected value has been changed
	 */
	handleJurisdictionChange = event => {
		let ClientInvoiceEstimateJurisdictionId = null;
		let estimateJurisdictionName = "";
		if (event) {
			({ value: ClientInvoiceEstimateJurisdictionId, label: estimateJurisdictionName } =
				event);
		}

		this.setState(
			prevState => ({
				estimateJurisdictionName,
				invoiceEstimate: {
					...prevState.invoiceEstimate,
					ClientInvoiceEstimateJurisdictionId,
				},
			}),
			() => {
				this.getJobEstimate(event);
			},
		);
	};

	/**
	 * Toggles the expanded state of a section in the job form
	 * @param {String} sectionName An identifier for the section to collapse or expand
	 */
	handleToggleSection = sectionName => {
		/*
		 * Unlike the previous version of the job form, we don't want to validate
		 * each section when it collapses, since we now allow users to save
		 * a job draft
		 */
		this.setState(prevState => ({
			form: {
				...prevState.form,
				[sectionName]: {
					...prevState.form[sectionName],
					_expanded: !prevState.form[sectionName]._expanded,
				},
			},
		}));
	};

	/**
	 * Collapses the section that is currently open and automatically expands the next incomplete section in the job form (from top to bottom)
	 * @param {String} currentSection The job form section that is currently expanded
	 */
	expandNextSection = currentSection => {
		const {
			isGeneralInfoValid,
			isPositionsValid,
			isPaymentDetailsValid,
			isOfficerFulfillmentValid,
		} = this.state;
		let nextSection;
		switch (currentSection) {
			case "generalInfo":
				if (!isPositionsValid) nextSection = "positions";
				else if (!isPaymentDetailsValid) nextSection = "paymentDetails";
				else if (!isOfficerFulfillmentValid) nextSection = "officerFulfillment";
				break;
			case "positions":
				if (!isPaymentDetailsValid) nextSection = "paymentDetails";
				else if (!isOfficerFulfillmentValid) nextSection = "officerFulfillment";
				else if (!isGeneralInfoValid) nextSection = "generalInfo";
				break;
			case "paymentDetails":
				if (!isOfficerFulfillmentValid)
					nextSection = this.isInvoicingFirstEnabled
						? "generalInfo"
						: "officerFulfillment";
				else if (!isGeneralInfoValid) nextSection = "generalInfo";
				else if (!isPositionsValid) nextSection = "positions";
				break;
			default:
				if (!isGeneralInfoValid) nextSection = "generalInfo";
				else if (!isPositionsValid) nextSection = "positions";
				else if (!isPaymentDetailsValid) nextSection = "paymentDetails";
				break;
		}

		if (nextSection) {
			this.setState(prevState => ({
				form: {
					...prevState.form,
					[currentSection]: {
						...prevState.form[currentSection],
						_expanded: false,
					},
					[nextSection]: {
						...prevState.form[nextSection],
						_expanded: true,
					},
				},
			}));
		} else {
			this.setState(
				prevState => ({
					form: {
						...prevState.form,
						[currentSection]: {
							...prevState.form[currentSection],
							_expanded: false,
						},
					},
				}),
				() => {
					if (window.innerWidth >= 992) window.scrollTo({ top: 0, behavior: "smooth" });
				},
			);
		}
	};

	togglePositionFormModal = (activePositionIndex, activePositionGroup) => {
		this.setState(prevState => ({
			showPositionFormModal: !prevState.showPositionFormModal,
			activePositionIndex,
			activePositionGroup,
		}));
	};

	/**
	 * Deletes a position from the list
	 * @param {Number} index The index of the position to delete in the current array of positions
	 */
	deletePosition = index => {
		const { lang } = global;
		// Destructuring and spreading to remove any reference to a deeply nested property
		const {
			form: {
				positions: {
					Jobs: [...Jobs],
				},
			},
			jobEditingProperties,
		} = this.state;

		const performDelete = () => {
			const newPositions = [...Jobs];
			// delete the position based on index
			newPositions.splice(index, 1);
			const isPositionsValid =
				newPositions.length > 0 &&
				newPositions.filter(item => item._isValid === false).length === 0;
			this.validateSection("positions", isPositionsValid);
			this.updateForm(
				"positions",
				{ Jobs: newPositions, _expanded: newPositions.length > 0 },
				true,
			);
		};

		if (jobEditingProperties.Id) {
			this.confirmationModal.openModal({
				title: lang.t("Delete Job Position"),
				message: lang.t("dynamic.Are you sure you want to delete the position", {
					positionName: Jobs[index]?.Title,
				}),
				confirmButton: `${lang.t("Yes")}, ${lang.t("Delete")}`,
				onConfirm: performDelete,
			});
		} else {
			performDelete();
		}
	};

	/**
	 * Updates values for properties in a given section.
	 * This method is passed to each section component as a prop in order to update the state of this HOC.
	 * @param {String} section The section of the job form to update values for
	 * @param {Object} newValues An object containing new values for properties within the specified section
	 * @param {Boolean} getNewEstimate Whether or not a new estimate needs to be calculated. Defaults to `true`
	 * @param {Function} callback An optional function called once values have been updated
	 */
	updateForm = (section, newValues, getNewEstimate = true, callback = undefined) => {
		const { positionFilter, form, positionWithPayCodeExist, rawAgencyPayCodes } = this.state;
		let _positionWithPayCodeExist = positionWithPayCodeExist;
		const auxNewValues = newValues;
		if (section === "positions") {
			if (positionFilter === 1) {
				auxNewValues.Jobs = newValues.Jobs.sort(this.sortPositionByName);
			} else if (positionFilter === 2) {
				auxNewValues.Jobs = newValues.Jobs.sort(this.sortPositionByRankName);
				auxNewValues.Jobs = auxNewValues.Jobs.sort(this.sortPositionByRank);
			} else if (positionFilter === 3) {
				auxNewValues.Jobs = newValues.Jobs.sort(this.sortPositionByTime);
			}

			_positionWithPayCodeExist = auxNewValues.Jobs.filter(job => !!job.PayCodeId).length > 0;

			if (_positionWithPayCodeExist) {
				auxNewValues.Jobs = newValues.Jobs.map(job => ({
					...job,
					Rate: utils.isPayRateValid(job.Rate) ? job.Rate : "",
				}));
			}

			this.setState(prevState => ({
				...prevState,
				form: {
					...prevState.form,
					paymentDetails: {
						...prevState.form.paymentDetails,
					},
				},
				positionWithPayCodeExist: _positionWithPayCodeExist,
			}));
		}

		if (section === "generalInfo") {
			const needToFilterPaycodes = () => {
				if (
					(!!form.generalInfo._startDate || !!newValues._startDate) &&
					!!newValues._startDate
				)
					return true;

				return false;
			};

			if (needToFilterPaycodes()) {
				this.filterPayCodes(
					!newValues._startDate ? form.generalInfo._startDate : newValues._startDate,
					rawAgencyPayCodes,
					!newValues._startTime ? form.generalInfo._startTime : newValues._startTime,
				);
			}
		}
		this.setState(
			prevState => ({
				...prevState,
				form: {
					...prevState.form,
					[section]: {
						...prevState.form[section],
						...auxNewValues,
					},
				},
			}),
			() => {
				// Get the updated state to use it as parameter for callback
				const { form: updatedForm } = this.state;
				if (getNewEstimate)
					this.getJobEstimate(
						undefined,
						callback ? () => callback(updatedForm) : undefined,
					);
				else if (callback) callback(updatedForm);
			},
		);
	};

	updateRequestProperties = updates => {
		this.setState(prevState => ({
			jobRequestProperties: {
				...prevState.jobRequestProperties,
				...updates,
			},
		}));
	};

	/**
	 * Marks the values of a section in the job form as valid or invalid
	 * @param {String} section The section to update validation status for
	 * @param {Boolean} isValid Whether the section is valid or not
	 */
	validateSection = (section, isValid) => {
		switch (section) {
			case "generalInfo":
				this.setState({ isGeneralInfoValid: isValid });
				break;
			case "positions":
				this.setState({ isPositionsValid: isValid });
				break;
			case "paymentDetails":
				this.setState({ isPaymentDetailsValid: isValid });
				break;
			case "officerFulfillment":
				this.setState({ isOfficerFulfillmentValid: isValid });
				break;
			default:
				break;
		}
	};

	/**
	 * Handles changes made in the Send Estimate modal and updated the job form accordingly
	 * @param {String} property The property to update
	 * @param {*} explicitValue An explicit value used to update a property. This parameter is ignored unless `property = estimateApprovalRequired`.
	 * @returns {(event:Event) => void} A method that accepts an HTML event for necessary handling
	 */
	handleEstimateModalFormChange = (property, explicitValue) => event => {
		switch (property) {
			case "estimatePostOption":
				this.setState({ estimatePostOption: event.target.value });
				break;
			case "estimateContactId":
				this.setState(prevState => ({
					invoiceEstimate: {
						...prevState.invoiceEstimate,
						ClientInvoiceEstimateContactId: event?.value ?? "",
					},
				}));
				break;
			case "estimateApprovalRequired":
				this.setState(prevState => ({
					invoiceEstimate: {
						...prevState.invoiceEstimate,
						RequireClientInvoiceEstimateApproval: explicitValue,
					},
				}));
				break;
			default:
				break;
		}
	};

	/** Resets flex shifts per position when the job is not an event */
	resetFlexJob = () => {
		const {
			form: { positions },
		} = this.state;
		this.setState(prevState => ({
			form: {
				...prevState.form,
				positions: {
					...prevState.form.positions,
					Jobs: positions.Jobs.map(item => ({
						...item,
						FlexJob: false,
						FlexJobMinHours: "",
					})),
				},
			},
		}));
	};

	/**
	 * @param {Object} formData Raw form data to format
	 * @returns {Object} A properly formatted object to be used for job creation
	 */
	prepareFormData = formData => {
		const {
			form: { generalInfo },
		} = this.state;
		const { user } = this.props;
		// Remove fields starting with underscore from the form data object
		const formToSend = Object.fromEntries(
			Object.entries(formData).filter(([key]) => !key.startsWith("_")),
		);
		const isJobEvent = generalInfo.JobEventTypeId === FORM_JOB_TYPES.EVENT.value;

		/**
		 * @param {String} startDate What date the job is scheduled to start
		 * @param {String} startTime What time the job is scheduled to start
		 * @param {String} endTime What time the job is scheduled to end
		 * @returns {Object} an object with formatted `StartDateTime` and `EndDateTime` strings
		 */
		const formatDates = (startDate, startTime, endTime) => {
			// date format must change if user is on iOS
			const formattedStartDate = utils.isIOSDevice
				? startDate.replace(/-/gi, "/")
				: utils.fixIELocaleString(startDate);
			const startDateTime = new Date(
				`${formattedStartDate} ${utils.fixIELocaleString(utils.convertTime12to24(startTime))}`,
			);
			const endDateTime = new Date(
				`${formattedStartDate} ${utils.fixIELocaleString(utils.convertTime12to24(endTime))}`,
			);
			// Handle scenario where Date objects may be invalid for some reason
			if (Number.isNaN(startDateTime.getTime()) || Number.isNaN(endDateTime.getTime())) {
				return { StartDateTime: "", EndDateTime: "" };
			}

			// If endDateTime earlier than startDateTime, add a day to EndDateTime
			// to indicate job ends the next day
			if (endDateTime < startDateTime) {
				endDateTime.setDate(endDateTime.getDate() + 1);
			}

			const startDateTimeMs =
				startDateTime.getTime() - startDateTime.getTimezoneOffset() * 60000;
			const endDateTimeMs = endDateTime.getTime() - endDateTime.getTimezoneOffset() * 60000;
			// Format dates
			return {
				StartDateTime: new Date(startDateTimeMs).toISOString().slice(0, -1),
				EndDateTime: new Date(endDateTimeMs).toISOString().slice(0, -1),
			};
		};

		const formatRecurrenceDate = dateToFormat => {
			const cleanDate = utils.fixIELocaleString(dateToFormat);
			const formattedDate = utils.formatDate(
				utils.isIOSDevice ? cleanDate.replace(/-/gi, "/") : cleanDate,
				undefined,
				"UTC",
			);
			return `${formattedDate}T00:00`;
		};

		formToSend.Jobs = formToSend.Jobs.map((item, SortOrder) => {
			// If a job type is not Event, its positions will receive the start and end times of the job;
			const { StartDateTime, EndDateTime } = formatDates(
				isJobEvent ? item._positionStartDate : formData._startDate,
				item._startTime !== "" ? item._startTime : formData._startTime,
				item._endTime !== "" ? item._endTime : formData._endTime,
			);

			// Find reporting positions for group since API will reject supervisors with groups containing no reports
			// In this case, retain the supervisor status but remove the position group ID property
			let { PositionGroupId } = item;
			if (
				item.SupervisorPosition &&
				formToSend.Jobs.filter(
					job => job.PositionGroupId === PositionGroupId && !job.SupervisorPosition,
				).length === 0
			) {
				PositionGroupId = undefined;
			}

			// Creating this constant for the array of objects allows for muation of object values
			const result = {
				// Remove fields starting with underscore from each position object
				...Object.fromEntries(Object.entries(item).filter(([key]) => !key.startsWith("_"))),
				StartDateTime,
				EndDateTime,
				PositionGroupId,
				// Add the property SortOrder (current index of the item)
				// This is done so positions show in the correct order on Job Details (Supervisor, reporting, ungrouped, etc)
				// If the job is edited, these properties should also be updated when saving
				SortOrder,
				JobCertifications: item.JobCertifications.map(({ value, label }) => ({
					OfficerCertificationTypeId: value,
					OfficerCertificationTypeName: label,
				})),
			};

			// When FlexJob is true and job is an event(ex. 6) use the flex values from the position modal
			// Otherwise use the flex values from the general info section
			if (result.FlexJob === true || formData._flexJob === true) {
				result.FlexJob =
					formToSend.JobEventTypeId === 6 ? result.FlexJob : formData._flexJob;
				result.FlexJobMinHours =
					formToSend.JobEventTypeId === 6
						? parseFloat(result.FlexJobMinHours)
						: parseFloat(formData._flexJobMinHours);
			}
			// Instead of sending in blank values for FlexJob or FlexJobMinHours delete these values from the api request when FlexJob is false
			// The API will default FlexJob to false and FlexJobMinHours to 0
			if (result.FlexJob === false) {
				delete result.FlexJob;
				delete result.FlexJobMinHours;
			}

			return result;
		});

		// Set job StartDateTime and EndDateTime values when the type is not Event
		if (formToSend.JobEventTypeId !== FORM_JOB_TYPES.EVENT.value) {
			const { StartDateTime, EndDateTime } = formatDates(
				formData._startDate,
				formData._startTime,
				formData._endTime,
			);

			formToSend.StartDateTime = StartDateTime;
			formToSend.EndDateTime = EndDateTime;
		}

		// If job is not recurring remove JobEventRecurrenceRule
		if (!formData._isRecurring) {
			delete formToSend.JobEventRecurrenceRule;
		} else {
			const { RepeatsOn, StartsOn, EndsOn } = formData.JobEventRecurrenceRule;
			// Format the dates to YYYY-MM-DD and turn the elements in RepeatsOn into a string
			formToSend.JobEventRecurrenceRule.StartsOn = utils.fixIELocaleString(
				formatRecurrenceDate(StartsOn),
			);
			if (EndsOn !== "" && (utils.isDesktopSafari || utils.isIE)) {
				// Desktop Safari & IE require different formatting since there is no support for date inputs
				formToSend.JobEventRecurrenceRule.EndsOn = utils.fixIELocaleString(
					formatRecurrenceDate(EndsOn),
				);
			} else if (EndsOn !== "") {
				formToSend.JobEventRecurrenceRule.EndsOn = formatRecurrenceDate(EndsOn);
			} else {
				formToSend.JobEventRecurrenceRule.EndsOn = "";
			}
			formToSend.JobEventRecurrenceRule.RepeatsOn =
				RepeatsOn instanceof Array && RepeatsOn.length > 0 ? RepeatsOn.join() : "";
		}
		if (user.isCoordinator()) {
			formToSend.SupervisorContactId = user.ContactId;
		}

		if (formToSend.IsRKPay ||
			formToSend.JobInvoicedTypeId === JOB_INVOICED_TYPES.OFFICER_INVOICING
		) {
			delete formToSend.PaymentMethod;
		}
		return formToSend;
	};

	validateEnforcingV2Options = () => {
		const { user } = this.props;
		const {
			form: { paymentDetails },
			isClientEnforceV2NonRKPayInvoicing,
		} = this.state;

		const officerInvoicingV3EnabledForOrg = user.Features.some(f =>
			f.toLowerCase().includes("officerinvoicingv3"),
		);

		if (!isClientEnforceV2NonRKPayInvoicing || !officerInvoicingV3EnabledForOrg) {
			return true;
		}

		if (
			paymentDetails.JobInvoicedTypeId === JOB_INVOICED_TYPES.OFFICER_INVOICING ||
			(paymentDetails.JobInvoicedTypeId === JOB_INVOICED_TYPES.AGENCY_INVOICING &&
				(paymentDetails.RequirePrepayment ||
					paymentDetails.ExcludeOfficerRate === true ||
					paymentDetails.WaiveJurisdictionFees ||
					paymentDetails.TransferPaymentsToAgency ||
					paymentDetails.TermsAndConditionsAcknowledge === true))
		) {
			return false;
		}

		return true;
	};

	showEnforceV2ValidationError = sendEstimatePressed => {
		const { lang } = global;
		utils.notify({
			type: "error",
			message: lang.t("Job enforceV2 save validation_"),
			timeOut: 1500,
		});

		this.setState(
			() => ({
				[sendEstimatePressed ? "estimateButtonState" : "saveButtonState"]: "error",
			}),
			() =>
				this.setState({
					[sendEstimatePressed ? "estimateButtonState" : "saveButtonState"]: "",
				}),
		);
	};

	/**
	 * Validates all job information prior to making the API request to create a new job
	 * @param {Boolean} sendEstimatePressed Whether the 'Send Estimate' button was clicked or not. Defaults to `false`.
	 */
	handleSave = (sendEstimatePressed = false) => {
		const { params } = this.props;
		const {
			form: {
				positions: { Jobs },
			},
			isGeneralInfoValid,
			isPositionsValid,
			isPaymentDetailsValid,
			isOfficerFulfillmentValid,
			isClientEnforceV2NonRKPayInvoicing,
		} = this.state;

		// When editing a job and pressing Save Job, collapse all sections & keep the original send estimate settings
		this.setState(
			prevState => ({
				form: {
					...prevState.form,
					generalInfo: {
						...prevState.form.generalInfo,
						_expanded: !isGeneralInfoValid,
					},
					positions: {
						...prevState.form.positions,
						_expanded: !isPositionsValid && Jobs.length > 0,
						Jobs: prevState.form.positions.Jobs.map(job => ({
							...job,
							Rate: !job.Rate || job.Rate === "" ? 0 : job.Rate,
						})),
					},
					paymentDetails: {
						...prevState.form.paymentDetails,
						_expanded: !isPaymentDetailsValid,
					},
					officerFulfillment: {
						...prevState.form.officerFulfillment,
						_expanded: !isOfficerFulfillmentValid,
					},
				},
				invoiceEstimate: {
					...prevState.invoiceEstimate,
					SendClientInvoiceEstimate:
						params?.jobId && !sendEstimatePressed
							? prevState.invoiceEstimate.SendClientInvoiceEstimate
							: sendEstimatePressed,
				},
				showInvalidFields: false,
			}),
			() => {
				const {
					invoiceEstimate,
					form: {
						paymentDetails: { IsRKPay },
					},
				} = this.state;
				const { user } = this.props;
				const isInvoicingV3 = user.Features.some(f => f.toLowerCase() === "invoicingv3");

				if (this.enforceV2NonRKPayInvoicingEnabled && !this.validateEnforcingV2Options()) {
					this.showEnforceV2ValidationError(sendEstimatePressed);
					return;
				}

				if (
					!isGeneralInfoValid ||
					!isPositionsValid ||
					!isPaymentDetailsValid ||
					!isOfficerFulfillmentValid
				) {
					this.setState(
						prevState => ({
							showInvalidFields: true,
							[sendEstimatePressed ? "estimateButtonState" : "saveButtonState"]:
								"error",
							invoiceEstimate: {
								...prevState.invoiceEstimate,
								SendClientInvoiceEstimate: sendEstimatePressed
									? false
									: prevState.invoiceEstimate.SendClientInvoiceEstimate,
							},
						}),
						() =>
							this.setState({
								[sendEstimatePressed ? "estimateButtonState" : "saveButtonState"]:
									"",
							}),
					);
					utils.notify({
						type: "error",
						message: "Please verify that all required info has been entered",
						timeOut: 1500,
					});
					return;
				}

				if (!IsRKPay && (!isInvoicingV3 || isClientEnforceV2NonRKPayInvoicing)) {
					this.setState(prevState => ({
						form: {
							...prevState.form,
							paymentDetails: {
								...prevState.form.paymentDetails,
								TransferPaymentsToAgency: false,
							},
						},
					}));
				}

				this.setState(
					sendEstimatePressed
						? { estimateButtonState: "loading" }
						: { saveButtonState: "loading" },
				);
				// Validate jurisdiction id for the final job estimate call
				if (
					invoiceEstimate.SendClientInvoiceEstimate &&
					!invoiceEstimate.ClientInvoiceEstimateJurisdictionId
				) {
					this.setState(
						prevState => ({
							showInvalidFields: true,
							[sendEstimatePressed ? "estimateButtonState" : "saveButtonState"]:
								"error",
							invoiceEstimate: {
								...prevState.invoiceEstimate,
								SendClientInvoiceEstimate: sendEstimatePressed
									? false
									: prevState.invoiceEstimate.SendClientInvoiceEstimate,
							},
						}),
						() =>
							this.setState({
								[sendEstimatePressed ? "estimateButtonState" : "saveButtonState"]:
									"",
							}),
					);
					utils.notify({
						type: "error",
						message: "A jurisdiction is required to continue.",
						timeOut: 1500,
					});
					return;
				}

				this.getJobEstimate(undefined, cb => {
					if (cb?.error) {
						this.setState({
							estimateButtonState: "",
							saveButtonState: "",
							showInvalidFields: true,
						});
						utils.notify({
							type: "error",
							message: "Error calculating job estimate",
							timeOut: 1500,
						});
						return;
					}
					if (sendEstimatePressed) {
						this.setState(prevState => ({
							showSendEstimateModal: true,
							estimateButtonState: "",
							invoiceEstimate: {
								...prevState.invoiceEstimate,
								SendClientInvoiceEstimate: true,
							},
						}));
						return;
					}
					this.handleJobCreation(undefined, sendEstimatePressed);
				});
			},
		);
	};

	/**
	 * Performs further checks and validations on the job form request prior to submitting a request to the API
	 * @param {Object} estimateOptions The options selected by the user when sending an estimate (if one was sent)
	 * @param {Boolean} sendEstimatePressed Whether the 'Send Estimate' button was clicked or not
	 */
	handleJobCreation = (estimateOptions, sendEstimatePressed) => {
		// Pranav
		const {
			estimatePostOption,
			form: { generalInfo, positions, paymentDetails, officerFulfillment },
			jobEditingProperties,
			invoiceEstimate,
			jobRequestProperties: { requestId },
		} = this.state;
		const { params } = this.props;
		const { lang } = global;

		const formData = cloneDeep({
			...generalInfo,
			...positions,
			...paymentDetails,
			...officerFulfillment,
		});

		let formToSend = this.prepareFormData(formData);
		// If the job is being created from a client request, we need to add it to the form for tracking purposes
		if (requestId) formToSend.ClientJobRequestId = requestId;
		const {
			SendClientInvoiceEstimate,
			ClientInvoiceEstimateJurisdictionId,
			ClientInvoiceEstimateContactId,
			RequireClientInvoiceEstimateApproval,
		} = invoiceEstimate;
		formToSend.SendClientInvoiceEstimate = SendClientInvoiceEstimate;
		if (SendClientInvoiceEstimate) {
			formToSend = {
				...formToSend,
				RequireClientInvoiceEstimateApproval:
					RequireClientInvoiceEstimateApproval || paymentDetails.RequirePrepayment,
				ClientInvoiceEstimateJurisdictionId,
				ClientInvoiceEstimateContactId,
			};

			if (sendEstimatePressed) {
				formToSend = {
					...formToSend,
					...estimateOptions,
					Posted: estimatePostOption === "automatic",
				};
			}
		}

		// Functionality to create the requested job
		const create = () => {
			// If an existing job is edited, add the necessary Ids to the request to update properly
			if (params?.jobId) {
				const formEditProperties = Object.fromEntries(
					Object.entries(jobEditingProperties).filter(([key]) => !key.startsWith("_")),
				);
				const formToUpdate = {
					...formToSend,
					...formEditProperties,
					updateEstimate: SendClientInvoiceEstimate,
				};

				// Check if jobEvent is part of a recurrent set and if all recurrences should be updated
				if (jobEditingProperties.JobEventRecurrenceRuleId) {
					return this.openRecursiveConfirmationModal(
						params.jobId,
						formToUpdate,
						sendEstimatePressed,
					);
				}

				this.saveJobEvent(
					params.jobId,
					formToUpdate,
					this.openConflictsModal,
					sendEstimatePressed,
				);
			} else {
				this.saveJobEvent(null, formToSend, this.openConflictsModal, sendEstimatePressed);
			}

			return true;
		};

		// Check if the jobEvent lasts more than 12 hours
		const { JobEventTypeId, StartDateTime, EndDateTime } = formToSend;
		const jobHours =
			(new Date(EndDateTime).getTime() - new Date(StartDateTime).getTime()) /
			(1000 * 60 * 60);
		this.setState(
			estimateOptions ? { estimateButtonState: "loading" } : { saveButtonState: "loading" },
		);
		if (JobEventTypeId !== FORM_JOB_TYPES.EVENT.value && jobHours > 12) {
			this.confirmationModal.openModal({
				title: lang.t("Lengthy Job Confirmation"),
				message: lang.t("Your job is over 12 hours, are you sure you want to do that_"),
				confirmButton: `${lang.t("Yes")}, ${lang.t("Save Job")}`,
				onConfirm: () => {
					create();
				},
				onCancel: () => {
					this.setState(
						sendEstimatePressed ? { estimateButtonState: "" } : { saveButtonState: "" },
					);
				},
			});
		} else {
			create();
		}
	};

	closeSendEstimateModal = () => {
		const { originalSendEstimateSettings } = this.state;
		const { params } = this.props;

		// Only reset values if we are not editing a job. When editing, keep it as it was
		// If editing a job, reset the invoice estimate
		if (params?.jobId) {
			this.setState(prevState => ({
				showSendEstimateModal: false,
				invoiceEstimate: {
					...prevState.invoiceEstimate,
					...originalSendEstimateSettings,
				},
			}));
		} else {
			this.setState(prevState => ({
				showSendEstimateModal: false,
				invoiceEstimate: {
					...prevState.invoiceEstimate,
					RequireClientInvoiceEstimateApproval: false,
					SendClientInvoiceEstimate: false,
				},
			}));
		}
	};

	openConflictsModal = (data, onOverrideConflicts) => {
		this.conflictsModal.openModal({
			message: data.Message,
			events: data.Errors,
			onOverrideConflicts,
		});
	};

	openSeriesConfirmationModal = (actionType, onConfirm, onClose) => {
		this.setState({
			seriesConfirmationModal: {
				show: true,
				onConfirm,
				onClose,
				actionType,
			},
		});
	};

	closeSeriesConfirmationModal = () => {
		this.setState({ seriesConfirmationModal: { ...this.initialSeriesConfirmationModal } });
	};

	openRecursiveConfirmationModal = (jobId, formToSend, sendEstimatePressed) => {
		const onConfirm = updateAll => {
			this.setState(
				prevState => ({
					saveButtonState: sendEstimatePressed ? prevState.saveButtonState : "loading",
					estimateButtonState: sendEstimatePressed
						? "loading"
						: prevState.estimateButtonState,
					jobEditingProperties: {
						...prevState.jobEditingProperties,
						updateAllUpcoming: !!updateAll,
					},
				}),
				() => {
					this.saveJobEvent(
						jobId,
						{ ...formToSend, updateAllUpcoming: updateAll },
						this.openConflictsModal,
						sendEstimatePressed,
					);
				},
			);
		};
		const onClose = () => {
			this.setState(
				sendEstimatePressed ? { estimateButtonState: "" } : { saveButtonState: "" },
			);
			this.closeSeriesConfirmationModal();
		};

		this.openSeriesConfirmationModal("update", onConfirm, onClose);
	};

	/**
	 * Makes a request to the API to create a new job or save changes to an existing job
	 * @param {String|Number} jobId The ID number for the job to update (if a job is being edited)
	 * @param {Object} formToSend The form object to send with the API request
	 * @param {Function} callback A method called in the event that a conflict is found with job creation/update
	 * @param {Boolean} sendEstimatePressed Whether the 'Send Estimate' button was clicked or not
	 * @param {Boolean} overrideConflicts Flag to override assignment conflicts
	 */
	saveJobEvent = async (
		jobId,
		formToSend,
		callback,
		sendEstimatePressed,
		overrideConflicts = false,
	) => {
		const { lang } = global;
		const {
			router: { replace },
			location,
			user,
		} = this.props;
		const {
			isJobPaidFor,
			form: { generalInfo },
		} = this.state;
		const isInvoicingV3 = user.Features.some(f => f.toLowerCase() === "invoicingv3");
		const officerInvoicingV3Enabled = user.Features.some(f => f.toLowerCase().includes("officerinvoicingv3"));
		// copy reference to formToSend.JobEventAttachments so we can use it later
		const sentAttachments = (formToSend.JobEventAttachments ?? []).filter(
			attachment => !attachment.existingFile,
		);
		this.setState({ loaderEntireScreen: true });
		const successCallback = response => {
			// Track job event creation
			const isCreate = !jobId;
			if (isCreate) {
				const jobEventTrackingPayload = {
					organizationId: user.Organization.Id,
				};
				const attachment = sentAttachments.length > 0 ? sentAttachments[0] : null;

				const formatFileSizeInMB = fileSizeInBytes =>
					`${(fileSizeInBytes / (1024 * 1024)).toFixed(2)} MB`;
				if (attachment) {
					jobEventTrackingPayload.hasJobDescriptionAttachment = true;
					jobEventTrackingPayload.clientId = generalInfo._clientId;
					jobEventTrackingPayload.jobTypeId = formToSend.JobEventTypeId;
					jobEventTrackingPayload.numberOfPositions = formToSend.Jobs.length;
					jobEventTrackingPayload.isRecurring = !!formToSend.JobEventRecurrenceRuleId;
					if (!attachment.existingFile) {
						jobEventTrackingPayload.fileSize = formatFileSizeInMB(attachment.file.size);
						jobEventTrackingPayload.fileType = attachment.file.type || "";
					}
				}
				AnalyticsService.trackEvent({
					category: ANALYTICS_EVENTS_CATEGORIES.CREATE_JOB_EVENT,
					action: ANALYTICS_EVENTS_ACTIONS.JOB_EVENT_CREATED,
					customParameters: jobEventTrackingPayload,
				});
			}

			// If we were working on a job draft, delete that draft
			if (location.query?.draftId) {
				JobEventDraftsService.deleteJobDraft(location.query.draftId)
					.then(() => {})
					.catch(() => {});
			}
			let newJobId = jobId;
			if (
				!jobId &&
				response.data?.JobEvents instanceof Array &&
				response.data?.JobEvents.length > 0
			) {
				newJobId = response.data.JobEvents[0].Id;
			}
			this.setState(
				sendEstimatePressed
					? { estimateButtonState: "success" }
					: { saveButtonState: "success" },
				() => {
					replace(newJobId ? `/jobs/${newJobId}` : "/jobs");
				},
			);
			this.setState({ loaderEntireScreen: false });
		};

		const errorCallback = error => {
			const {
				response: { data, status },
			} = error;
			this.setState(
				sendEstimatePressed
					? { estimateButtonState: "error" }
					: { saveButtonState: "error" },
			);
			this.setState({ loaderEntireScreen: false });
			if (status === 409 && callback) {
				callback(data, () => {
					this.saveJobEvent(jobId, formToSend, callback, sendEstimatePressed, true);
				});
			} else {
				utils.notify({
					type: "error",
					message: data.Message ?? lang.t("Something went wrong"),
					timeOut: 1500,
				});
			}
		};

		const { PaymentMethod, ...formToSendNoRkPay } = formToSend;

		if (this.jobDescriptionAttachments) {
			// Check if there are any job event attachments to upload
			if (formToSend.JobEventAttachments && formToSend.JobEventAttachments.length > 0) {
				try {
					// For now, we're only handling one attachment
					const fileAttachment = formToSend.JobEventAttachments[0];
					if (!fileAttachment.existingFile) {
						const response = await JobService.uploadJobEventAttachment(
							fileAttachment.file,
						);

						if (response && response.data) {
							// Add the attachment ID to the job payload
							formToSendNoRkPay.JobAttachment = {
								AttachmentId: response.data,
							};
						}
					} else {
						// If the attachment is an existing one, we just need to set the existing ID
						formToSendNoRkPay.JobAttachment = {
							AttachmentId: fileAttachment.id,
						};
					}
				} catch (error) {
					utils.notify({
						type: "error",
						message: lang.t("Failed to upload attachment"),
						timeOut: 1500,
					});
				}
			}

			/**
			 * If the job event had an existing attachment, but the user removed it,
			 * we need to remove the JobAttachment property from the formToSendNoRkPay
			 */
			if (formToSend.JobEventAttachments && formToSend.JobEventAttachments.length === 0) {
				delete formToSendNoRkPay.JobAttachment;
			}

			/**
			 * remove JobEventAttachments from the formToSendNoRkPay object
			 * since it is not needed in the API request.
			 */
			delete formToSendNoRkPay.JobEventAttachments;
		}
		if (formToSendNoRkPay.JobInvoicedTypeId === 1) {
			// if the officerInvoicingV3 flag is enabled the IsRKPay should be false.
			formToSendNoRkPay.IsRKPay = !officerInvoicingV3Enabled;
			formToSendNoRkPay.ExcludeOfficerRate = false;
		} else {
			formToSendNoRkPay.PaymentMethod = PaymentMethod;
		}

		if (!this.isInvoicingDetailsComponentEnabled || !isInvoicingV3) {
			delete formToSendNoRkPay.ClientPaysForTheJob;
			delete formToSendNoRkPay.ElectronicallyBilled;
			delete formToSendNoRkPay.TermsAndConditionsAcknowledge;
			delete formToSendNoRkPay.ExcludeOfficerRate;
			delete formToSendNoRkPay.SchedulingJobType;
			delete formToSendNoRkPay.AdditionalInformation;
			delete formToSendNoRkPay.InvoicingType;
			delete formToSendNoRkPay.PaymentDetails;
			delete formToSendNoRkPay.AdditionalPaymentMethod;
			delete formToSendNoRkPay.NotInvoicingInformation;
		}

		if (jobId) {
			const queryParams = {
				updateAllUpcoming: formToSend.updateAllUpcoming,
				updateEstimate: formToSend.SendClientInvoiceEstimate,
				overrideConflicts,
			};
			if (isJobPaidFor || !sendEstimatePressed) {
				queryParams.updateEstimate = false;
			}

			JobService.edit(queryParams, formToSendNoRkPay)
				.then(successCallback)
				.catch(errorCallback);
		} else {
			JobService.add(formToSendNoRkPay).then(successCallback).catch(errorCallback);
		}
	};

	/** Captures the current state of the job form and submits a request to save the job draft with those values */
	saveDraft = () => () => {
		const {
			estimateJurisdictionName,
			form,
			locationCoordinates,
			invoiceEstimate,
			isGeneralInfoValid,
			isPositionsValid,
			isPaymentDetailsValid,
			isOfficerFulfillmentValid,
			jobRequestProperties,
		} = this.state;
		const {
			router: { replace },
			location,
		} = this.props;
		const {
			generalInfo: { Name: title },
		} = form;

		// Copy to prevent mutating the original form object
		const formCopy = cloneDeep(form);

		if (this.jobDescriptionAttachments) {
			delete formCopy.generalInfo.JobEventAttachments;
		}

		const draftData = {
			estimateJurisdictionName,
			form: formCopy,
			locationCoordinates,
			invoiceEstimate,
			isGeneralInfoValid,
			isPositionsValid,
			isPaymentDetailsValid,
			isOfficerFulfillmentValid,
			jobRequestProperties,
		};
		if (title === "") {
			utils.notify({
				type: "error",
				message: "A job draft must have a name",
				timeOut: 1500,
			});
			this.setState({ draftButtonState: "error" }, () =>
				this.setState({ draftButtonState: "" }),
			);
		} else if (location.query?.draftId) {
			const {
				query: { draftId: id },
			} = location;
			JobEventDraftsService.updateJobDraft({ id, title, draftData })
				.then(() => {
					this.setState({ draftButtonState: "success" }, () => {
						utils.notify({
							type: "success",
							message: "Updated job draft",
							timeOut: 1500,
						});
						replace("/jobs/drafts");
					});
				})
				.catch(() => {
					this.setState({ draftButtonState: "error" });
					utils.notify({
						type: "error",
						message: "Unable to save job draft",
						timeOut: 1500,
					});
				});
		} else {
			JobEventDraftsService.createJobDraft({ title, draftData })
				.then(() => {
					this.setState({ draftButtonState: "success" }, () => replace("/jobs/drafts"));
				})
				.catch(() => {
					this.setState({ draftButtonState: "error" });
					utils.notify({
						type: "error",
						message: "Unable to save job draft",
						timeOut: 1500,
					});
				});
		}
	};

	getPositionGroupCount = positionGroupId => {
		const {
			form: {
				positions: { Jobs },
			},
		} = this.state;
		if (positionGroupId) return Jobs.filter(j => j.PositionGroupId === positionGroupId).length;
		return 0;
	};

	handlePositionChanges = e => {
		const { name, value } = e.target;
		const { rawAgencyPayCodes, positionStartTime } = this.state;
		const formattedValue = utils.isIOSDevice ? value.replace(/\//gi, "-") : value;

		if (name === "positionStartDate") {
			this.filterPayCodes(formattedValue, rawAgencyPayCodes, positionStartTime);
		}

		// TODO: Uncomment those lines when filter paycodes by time in addition to date.
		// if (name === 'positionStartTime') {
		// 	this.filterPayCodes(positionStartDate, rawAgencyPayCodes, formattedValue);
		// }

		if (
			formattedValue !== "" &&
			name === "officerRate" &&
			!formattedValue.match(/^\d*\.?\d{0,2}$/g)
		)
			return;
		if (
			formattedValue !== "" &&
			name === "officersNeeded" &&
			!formattedValue.match(/^[0-9]\d*$/g)
		)
			return;

		this.setState({ [name]: formattedValue });
	};

	/** Validates the current section and saves latest position value to the HOC */
	addPosition = () => {
		const {
			form: { generalInfo, positions },
			positionName,
			positionStartDate,
			officersNeeded,
			officerRate,
			positionStartTime,
			positionEndTime,
			PayCodeId,
			PTAEOCodeId,
			positionRate,
			positionFilter,
		} = this.state;

		const { HOURLY, PAY_CODE } = PAY_RATE_TYPE;

		const {
			user: {
				Organization: { IsPayCodeMandatory },
			},
		} = this.props;

		const isJobEvent = generalInfo.JobEventTypeId === FORM_JOB_TYPES.EVENT.value;
		let _isValid = true;
		let _startTime;
		let _endTime;
		if (isJobEvent) {
			_startTime = positionStartTime;
			_endTime = positionEndTime;
		} else {
			_startTime = generalInfo._startTime;
			_endTime = generalInfo._endTime;
		}

		if (
			isJobEvent &&
			positionName.trim() === "" &&
			positionStartDate.trim() === "" &&
			officersNeeded.toString().trim() === "" &&
			(!officerRate || officerRate.toString().trim() === "") &&
			_startTime.trim() === "" &&
			_endTime.trim() === "" &&
			(!PayCodeId || PayCodeId.toString().trim() === "")
		) {
			this.setState({ isPositionValid: false });
			return;
		}

		if (
			!isJobEvent &&
			positionName.trim() === "" &&
			officersNeeded.toString().trim() === "" &&
			officerRate.toString().trim() === ""
		) {
			this.setState({ isPositionValid: false });
			return;
		}

		// Validation logic
		if (positionName.trim() === "") _isValid = false;
		if (officersNeeded.toString().trim() === "" || officersNeeded.toString().trim() === "0")
			_isValid = false;
		if (
			isJobEvent &&
			(_startTime.trim() === "" || _endTime.trim() === "" || positionStartDate.trim() === "")
		)
			_isValid = false;
		else if (
			(utils.isIE || utils.isDesktopSafari) &&
			(_startTime.replace(/_/g, "").length < 5 || _endTime.replace(/_/g, "").length < 5)
		) {
			_isValid = false;
		}

		switch (positionRate) {
			case HOURLY:
				_isValid = !utils.isPayRateValid(officerRate) ? false : _isValid;
				break;
			case PAY_CODE:
				_isValid = !PayCodeId || PayCodeId.toString().trim() === "" ? false : _isValid;
				break;
			default:
				break;
		}
		const maxSortOrder = positions.Jobs.length
			? Math.max(...positions.Jobs.map(j => j.SortOrder))
			: -1;

		const newPosition = {
			Title: positionName,
			OfficersNeeded: officersNeeded,
			JobCertifications: [],
			RequiredJurisdictionAssets: [],
			VehicleTypes: [],
			_needsMultipleOfficers: parseInt(officersNeeded, 10) > 1,
			_isRovingPatrol: false,
			_assetsRequired: false,
			_certificationRequired: false,
			_hasAssignedOfficers: false,
			_initialRate: "",
			_isRankRequired: false,
			_isMaxRankRequired: false,
			_hasRankRestriction: false,
			Details: "",
			SupervisorPosition: false,
			RequestedOfficerRankId: "",
			MaxRequestedOfficerRankId: "",
			OfficerRankRequired: false,
			RovingPatrol: "",
			VehicleRequired: false,
			DressTypeId: 1,
			DressTypeNote: "",
			OfficerRequirements: "",
			FlexJob: false,
			FlexJobMinHours: "",
			SortOrder: maxSortOrder + 1,
			_positionStartDate: positionStartDate,
			_startTime,
			_endTime,
			_isValid,
			Rate: positionRate === HOURLY ? officerRate : "",
			PayCodeId: IsPayCodeMandatory || positionRate === PAY_CODE ? PayCodeId : "",
			PTAEOCodeId,
		};

		if (!_isValid) {
			this.setState({ isPositionValid: _isValid });
			return;
		}
		this.setState(
			{
				positionName: "",
				officersNeeded: "",
				officerRate: "",
				isPositionValid: _isValid,
				positionStartDate,
				positionStartTime: "",
				positionEndTime: "",
				PayCodeId: "",
				PTAEOCodeId: "",
				positionWithPayCodeExist: !!PayCodeId,
			},
			() => {
				document.getElementById("positionName");
				let newPositions = [...positions.Jobs, newPosition];
				if (positionFilter === 1) {
					newPositions = newPositions.sort(this.sortPositionByName);
				} else if (positionFilter === 2) {
					newPositions = newPositions.sort(this.sortPositionByRankName);
					newPositions = newPositions.sort(this.sortPositionByRank);
				} else if (positionFilter === 3) {
					newPositions = newPositions.sort(this.sortPositionByTime);
				}
				const isPositionsValid =
					newPositions.length > 0 &&
					newPositions.filter(item => item._isValid === false).length === 0;
				this.updateForm("positions", { Jobs: newPositions }, true, () => {
					this.validateSection("positions", isPositionsValid);
				});
			},
		);
	};

	setAgencyEstimateList = () => {
		const {
			isJobCompleted,
			form: {
				paymentDetails: { ExcludeOfficerRate },
				generalInfo: { _clientId },
			},
		} = this.state;

		this.setState({ agencyEstimateList: [] });

		if (this.enforceV2NonRKPayInvoicingEnabled && !this.validateEnforcingV2Options()) {
			this.showEnforceV2ValidationError(true);
			return;
		}

		if (!_clientId || _clientId === "") {
			this.setState(
				{
					showAgencyV3Options: true,
					estimateButtonState: "loading",
				},
				() => this.setState({ estimateButtonState: "" }),
			);
			return;
		}

		this.setState({ showAgencyV3Options: false, estimateButtonState: "loading" });

		const params = {
			displayCount: 100,
			pageNumber: 1,
			archived: false,
			isEstimate: !isJobCompleted,
			clientId: _clientId,
			sortBy: "IssueDate",
			asc: false,
			finalized: false,
			excludeOfficerRate: ExcludeOfficerRate,
			estimateFinalized: false,
		};
		PaymentService.getNonRKPayInvoices(undefined, params)
			.then(({ data: { ItemList } }) => {
				this.setState({ agencyEstimateList: ItemList || [] });
			})
			.catch(() => {})
			.finally(() => this.setState({ showAgencyV3Options: true, estimateButtonState: "" }));
	};

	/**
	 * Event handler for hovering over agency estimates in a list
	 * @param {Event} event HTML event to inspect for handling the hover event (onmouseover) properly
	 */
	handleEstimateHover = ({ target }) => {
		const parent = target.parentElement;
		const currentActive = parent.querySelector("li.active");
		if (currentActive !== target) {
			currentActive?.classList?.remove("active");
			target.classList.add("active");
			target.focus();
		}
	};

	/**
	 * Event handler that is triggered when a key is pressed while focused on the list of manual estimates for the client.
	 * @param {Event} event The HTML event to inspect for handling the keydown event properly
	 */
	handleKeyDown = event => {
		const { key } = event;
		const options = document.querySelectorAll("#agency-estimate-options > li");
		const activeIndex = Array.from(options).indexOf(
			document.querySelector("#agency-estimate-options > li.active"),
		);
		if ((key === "ArrowDown" || key === "ArrowRight") && activeIndex !== -1) {
			event.preventDefault();
			options[activeIndex].classList.remove("active");
			if (activeIndex === options.length - 1) {
				options[0].classList.add("active");
				options[0].focus();
			} else {
				options[activeIndex + 1].classList.add("active");
				options[activeIndex + 1].focus();
			}
		} else if ((key === "ArrowUp" || key === "ArrowLeft") && activeIndex !== -1) {
			event.preventDefault();
			options[activeIndex].classList.remove("active");
			if (activeIndex === 0) {
				options[options.length - 1].classList.add("active");
				options[options.length - 1].focus();
			} else {
				options[activeIndex - 1].classList.add("active");
				options[activeIndex - 1].focus();
			}
		} else if (key === "Escape") {
			this.setState({ showAgencyV3Options: false });
		}
	};

	addToV3Invoice = estimateId => {
		const { lang } = global;
		const {
			location: { query },
			params,
			router,
		} = this.props;
		// Collapse all sections
		this.setState(
			prevState => {
				const {
					form,
					isGeneralInfoValid,
					isPositionsValid,
					isPaymentDetailsValid,
					isOfficerFulfillmentValid,
				} = prevState;
				form.generalInfo._expanded = !isGeneralInfoValid;
				form.positions._expanded = !isPositionsValid && form.positions.Jobs.length > 0;
				form.positions.Jobs = form.positions.Jobs.map(job => ({
					...job,
					Rate: !job.Rate || job.Rate === "" ? 0 : job.Rate,
				}));
				form.paymentDetails._expanded = !isPaymentDetailsValid;
				form.officerFulfillment._expanded = !isOfficerFulfillmentValid;
				return { form, showInvalidFields: false, estimateButtonState: "loading" };
			},
			() => {
				const {
					form: { generalInfo, positions, paymentDetails, officerFulfillment },
					isGeneralInfoValid,
					isPositionsValid,
					isPaymentDetailsValid,
					isOfficerFulfillmentValid,
					invoiceEstimate,
					jobEditingProperties: editProps,
					jobRequestProperties: { requestId },
					isJobCompleted,
				} = this.state;

				// Validate required fields for each section
				if (
					!isGeneralInfoValid ||
					!isPositionsValid ||
					!isPaymentDetailsValid ||
					!isOfficerFulfillmentValid
				) {
					this.setState(
						{
							showInvalidFields: true,
							showAgencyV3Options: false,
							estimateButtonState: "error",
						},
						() => this.setState({ estimateButtonState: "" }),
					);
					utils.notify({
						type: "error",
						message: "Please verify that all required info has been entered",
						timeOut: 1500,
					});
					return;
				}

				// Validate jurisdiction id
				if (!invoiceEstimate.ClientInvoiceEstimateJurisdictionId) {
					this.setState({ showInvalidFields: true, estimateButtonState: "error" }, () =>
						this.setState({ sendEstimatePressed: "" }),
					);
					utils.notify({
						type: "error",
						message: "A jurisdiction is required to continue.",
						timeOut: 1500,
					});
					return;
				}

				this.getJobEstimate(undefined, cb => {
					if (cb?.error) {
						this.setState({
							estimateButtonState: "",
							showInvalidFields: true,
						});
						utils.notify({
							type: "error",
							message: "Error calculating job estimate",
							timeOut: 1500,
						});
						return;
					}

					const formData = cloneDeep({
						...generalInfo,
						...positions,
						...paymentDetails,
						...officerFulfillment,
					});

					const formToSend = this.prepareFormData(formData);
					// If the job is being created from a client request, we need to add it to the form for tracking purposes
					if (requestId) formToSend.ClientJobRequestId = requestId;

					// Save/update job functionality
					const handleSaveJob = jobForm => {
						const servicePromise = new Promise((resolve, reject) => {
							if (params?.jobId) {
								const formEditProps = Object.fromEntries(
									Object.entries(editProps).filter(
										([key]) => !key.startsWith("_"),
									),
								);
								// eslint-disable-next-line no-promise-executor-return
								return JobService.edit(
									{ updateAllUpcoming: formToSend.updateAllUpcoming },
									{ ...jobForm, ...formEditProps },
								)
									.then(res => resolve(res))
									.catch(err => reject(err));
							}
							// eslint-disable-next-line no-promise-executor-return
							return JobService.add(jobForm)
								.then(res => resolve(res))
								.catch(err => reject(err));
						});
						servicePromise
							.then(({ data: { JobEvents } }) => {
								// If we were working on a job draft, delete that draft
								if (query?.draftId)
									JobEventDraftsService.deleteJobDraft(query.draftId).catch(
										() => {},
									);

								let newJobId = params?.jobId;
								if (
									!params?.jobId &&
									JobEvents instanceof Array &&
									JobEvents.length > 0
								) {
									newJobId = JobEvents[0].Id;
								}

								this.setState({ estimateButtonState: "success" }, () => {
									const clientId = generalInfo._clientId;
									const queryParams = {
										clientId,
										estimate: !isJobCompleted,
										id: estimateId,
										jobs: newJobId,
									};
									router.replace({
										pathname: "/payments/manualinvoice",
										query: queryParams,
									});
								});
							})
							.catch(err => {
								const {
									response: { data, status },
								} = err;
								this.setState({ estimateButtonState: "error" }, () =>
									this.setState({ estimateButtonState: "" }),
								);

								if (status === 409) {
									this.conflictsModal.openModal({
										message: data.Message,
										events: data.Errors,
									});
								} else {
									utils.notify({
										type: "error",
										message: data.Message ?? lang.t("Something went wrong"),
										timeOut: 1500,
									});
								}
							});
					};

					// Functionality to create the requested job (wrapped in a function to be passable to the 'lengthy job warning' modal)
					const createJob = () => {
						// Check if jobEvent is part of a recurrent set and if all recurrences should be updated
						if (editProps.JobEventRecurrenceRuleId) {
							const onConfirm = updateAll => {
								this.setState(
									prevState => {
										const { jobEditingProperties } = prevState;
										jobEditingProperties.updateAllUpcoming = !!updateAll;
										return { jobEditingProperties };
									},
									() => {
										handleSaveJob({
											...formToSend,
											updateAllUpcoming: updateAll,
										});
									},
								);
							};
							const onClose = () => {
								this.setState({ estimateButtonState: "" });
								this.closeSeriesConfirmationModal();
							};
							this.openSeriesConfirmationModal("update", onConfirm, onClose);
							return;
						}

						handleSaveJob(formToSend);
					};

					// Check if the jobEvent lasts more than 12 hours
					const { JobEventTypeId, StartDateTime, EndDateTime } = formToSend;
					const jobHours =
						(new Date(EndDateTime).getTime() - new Date(StartDateTime).getTime()) /
						(1000 * 60 * 60);
					if (JobEventTypeId !== FORM_JOB_TYPES.EVENT.value && jobHours > 12) {
						this.confirmationModal.openModal({
							title: lang.t("Lengthy Job Confirmation"),
							message: lang.t(
								"Your job is over 12 hours, are you sure you want to do that_",
							),
							confirmButton: `${lang.t("Yes")}, ${lang.t("Save Job")}`,
							onConfirm: () => createJob(),
							onCancel: () => this.setState({ estimateButtonState: "" }),
						});
					} else {
						createJob();
					}
				});
			},
		);
	};

	formatPositionTime = time => {
		const { user } = this.props;
		let date = new Date(`1970-01-01 ${time}`);
		if (utils.isIOSDevice) {
			// Date creation in iOS requires slashes
			date = new Date(`1970/01/01 ${time}`);
		}
		return date.toLocaleString(undefined, {
			hour: "numeric",
			minute: "2-digit",
			hour12: user.UserPreferences !== "useMilitaryTime",
		});
	};

	doesPositionStartOnDate = (startDate, position) => {
		const { _positionStartDate } = position;
		const startDateMs = new Date(`${startDate}`).getTime();
		const nextDayMs = startDateMs + 1000 * 60 * 60 * 24;
		const jobStartMs = new Date(`${_positionStartDate}`).getTime();
		return jobStartMs >= startDateMs && jobStartMs < nextDayMs;
	};

	setEditingDate = date => {
		this.setState({ isEditingDate: date, newDate: date }, () => this.dateChangeInput?.focus());
	};

	// Move all positions on a certain day to new assigned date
	updatePositionDate = (date, e, save = false) => {
		const { form, rawAgencyPayCodes } = this.state;
		const { lang } = global;
		const dateRegex = /^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;
		const _payCodesIds = this.filterPayCodes(e.target.value, rawAgencyPayCodes, "12:00").map(
			p => p.value,
		);

		if (save && dateRegex.test(e.target.value)) {
			let newSortOrder = Math.max(...(form.positions.Jobs.map(j => j.SortOrder) || 0));

			form.positions.Jobs.forEach(job => {
				if (job._positionStartDate === date) {
					// eslint-disable-next-line no-param-reassign
					job._positionStartDate = e.target.value;

					if (!_payCodesIds.includes(job.PayCodeId) && !utils.isPayRateValid(job.Rate)) {
						// eslint-disable-next-line no-param-reassign
						job.PayCodeId = "";
						// eslint-disable-next-line no-param-reassign
						job._isValid = false;
						this.validateSection("positions", false);
						utils.notify({
							type: "error",
							message: lang.t(
								"The selected pay code is outside the start date range, please change it to a valid one",
							),
							timeOut: 1500,
						});
					} else {
						// eslint-disable-next-line no-param-reassign
						job._isValid = true;
					}

					// Push sortorder index as assigned
					newSortOrder++;
					// eslint-disable-next-line no-param-reassign
					job.SortOrder = newSortOrder;
				}
			});
			this.setState({ isEditingDate: "", form });
		}

		this.setState({ newDate: e.target.value });
	};

	// Duplicate entire day of positions to a new appended date
	duplicatePositionDate = date => {
		const { form } = this.state;
		// Find the last day with positions for the event and increase by one
		const lastDay = Math.max(
			...form.positions.Jobs.map(j => new Date(`${j._positionStartDate}T00:00:00`).getTime()),
		);
		const newDate = new Date(lastDay);
		newDate.setDate(newDate.getDate() + 1);

		let newSortOrder = Math.max(...form.positions.Jobs.map(j => j.SortOrder)) || 0;

		const newForm = cloneDeep(form);
		const newDateString = utils.formatDate(newDate);
		const jobsToCopy = form.positions.Jobs.filter(job => job._positionStartDate === date);
		jobsToCopy.forEach(j => {
			// eslint-disable-next-line no-param-reassign
			j._positionStartDate = newDateString;
			// eslint-disable-next-line no-param-reassign
			if (j.Id) delete j.Id;
			// Mutate all position group IDs to not conflict with existing
			// Note: Prepends max 4 digits due to int limits
			if (j.PositionGroupId) {
				let newPositionGroupId = j.PositionGroupId.replace("positionGroup-", "");
				if (newPositionGroupId.length > 13) {
					newPositionGroupId = newPositionGroupId.substr(4);
				}
				newPositionGroupId = `positionGroup-${newDateString.replaceAll("-", "").substr(-4)}${newPositionGroupId}`;
				// eslint-disable-next-line no-param-reassign
				j.PositionGroupId = newPositionGroupId;
			}
			// Push sortorder index as assigned
			newSortOrder++;
			// eslint-disable-next-line no-param-reassign
			j.SortOrder = newSortOrder;

			newForm.positions.Jobs.push(j);
		});

		this.setState({ form: newForm });
	};

	onPositionFilterChange = selection => {
		const { form } = this.state;
		let updatedPositions = form.positions.Jobs;
		if (selection == null) {
			return;
		}
		if (selection.value === 1) {
			updatedPositions = form.positions.Jobs.sort(this.sortPositionByName);
		} else if (selection.value === 2) {
			updatedPositions = form.positions.Jobs.sort(this.sortPositionByRankName);
			updatedPositions = updatedPositions.sort(this.sortPositionByRank);
		} else if (selection.value === 3) {
			updatedPositions = form.positions.Jobs.sort(this.sortPositionByTime);
		}
		form.positions.Jobs = updatedPositions;
		this.setState({ positionFilter: selection.value, form });
	};

	// Delete all positions from a given day
	deletePositionDate = date => {
		const { form } = this.state;
		const updatedPositions = form.positions.Jobs.filter(job => job._positionStartDate !== date);
		form.positions.Jobs = updatedPositions;
		this.setState({ form });
	};

	handleCheckboxChange = ({ target: { checked } }) => {
		this.setState({
			applyPTAEOcode: checked,
		});
	};

	handleChange = e => {
		const {
			target: { name, value, type, checked },
		} = e;

		let newValue = value;

		if (name === "positionRate") {
			newValue = parseInt(value, 10);
			this.setState({
				PayCodeId: "",
				officerRate: "",
			});
		}

		if (type === "checkbox") {
			if (name === "applyPTAEOcode") {
				newValue = checked;
			}
		}

		this.setState({
			[name]: newValue,
		});
	};

	handleSelectChange = (e, name) => {
		const { value } = e;

		this.setState({
			[name]: value,
		});
	};

	filterPayCodes = (_startDate, _rawAgencyPayCodes, _startTime) => {
		const _payCodes = utils.filterPayCodesByDateAndStatus(
			_startDate,
			_rawAgencyPayCodes,
			_startTime,
		);

		this.setState(
			{
				agencyPayCodes: _payCodes,
				PayCodeId: "",
			},
			() => this.validateSelectedPayCodes(),
		);

		return _payCodes;
	};

	getPayCodes = () => {
		const { form } = this.state;

		PayCodesService.getPaycodes()
			.then(({ data }) => {
				const _agencyPayCodes = data.filter(el => el.IsActive);
				const _payCodes = utils.filterPayCodesByDateAndStatus(
					form.generalInfo._startDate,
					_agencyPayCodes,
					form.generalInfo._startTime,
				);

				this.setState({ agencyPayCodes: _payCodes, rawAgencyPayCodes: data });
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: "Error loading Pay Codes",
					timeOut: 1500,
				});
			});
	};

	getPTAEOCodes = () => {
		const { lang } = global;

		OrganizationService.getPTAEOCodes()
			.then(({ data }) => {
				const ptaeocodes = data.map(({ Id, Code }) => ({
					value: Id.toString(),
					label: Code,
				}));
				this.setState({ agencyPTAEOCodes: ptaeocodes });
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error loading PTAEO codes"),
					timeOut: 1500,
				});
			});
	};

	toggleAddingNewPosition = () => {
		this.setState(prevState => ({ addingNewPosition: !prevState.addingNewPosition }));
	};

	sortPositionByName = (a, b) => {
		if (a.Title.toLowerCase() < b.Title.toLowerCase()) {
			return -1;
		}
		if (a.Title.toLowerCase() > b.Title.toLowerCase()) {
			return 1;
		}
		return 0;
	};

	sortPositionByRank = (a, b) => {
		let auxRankA = a.RequestedOfficerRankWeight;
		let auxRankB = b.RequestedOfficerRankWeight;
		if (!a._isRankRequired && !a._isMaxRankRequired) {
			auxRankA = -1;
		} else if (!a._isRankRequired && a._isMaxRankRequired) {
			auxRankA = a.MaxRequestedOfficerRankWeight;
		}
		if (!b._isRankRequired && !b._isMaxRankRequired) {
			auxRankB = -1;
		} else if (!b._isRankRequired && b._isMaxRankRequired) {
			auxRankB = b.MaxRequestedOfficerRankWeight;
		}
		if (auxRankA < auxRankB) {
			return 1;
		}
		if (auxRankA > auxRankB) {
			return -1;
		}
		return 0;
	};

	sortPositionByRankName = (a, b) => {
		let auxRankA = a.RequestedOfficerRank;
		let auxRankB = b.RequestedOfficerRank;
		if (!a._isRankRequired && !a._isMaxRankRequired) {
			auxRankA = "ZZ";
		} else if (!a._isRankRequired && a._isMaxRankRequired) {
			auxRankA = a.MaxRequestedOfficerRank;
		}
		if (!b._isRankRequired && !b._isMaxRankRequired) {
			auxRankB = "ZZ";
		} else if (!b._isRankRequired && b._isMaxRankRequired) {
			auxRankB = b.MaxRequestedOfficerRank;
		}
		if (auxRankA < auxRankB) {
			return -1;
		}
		if (auxRankA > auxRankB) {
			return 1;
		}
		return 0;
	};

	sortPositionByTime = (a, b) => {
		const { user } = this.props;
		const hour12time = user.UserPreferences !== "useMilitaryTime";
		let startTimeA = a._startTime;
		let startTimeB = b._startTime;
		if (hour12time) {
			startTimeA = utils.convertTime12to24(a._startTime);
			startTimeB = utils.convertTime12to24(b._startTime);
		}
		if (startTimeA < startTimeB) {
			return -1;
		}
		if (startTimeA > startTimeB) {
			return 1;
		}
		return 0;
	};

	/** Displays a confirmation modal prompting the user to modify the Transfer officer payments to agency */
	updateTransferPaymentsToAgency = value => {
		const { lang } = global;
		const { form } = this.state;
		const { paymentDetails } = form;

		const message = value
			? lang.t(
					"Selecting this option will cause payments to be sent to the Agency instead of the officers. Are you sure you want to enable this_",
				)
			: lang.t(
					"Selecting this option will cause payments to be sent to the officer instead of the agency. Are you sure you want to disable this_",
				);

		this.confirmationModal.openModal({
			title: value
				? lang.t("Transfer Payments to Agency")
				: lang.t("Transfer payments to officer"),
			message,
			cancelButton: lang.t("Cancel"),
			confirmButton: value
				? lang.t("Yes, transfer payments to the agency")
				: lang.t("Yes, transfer payments to the officer"),
			onConfirm: () =>
				this.updateForm("paymentDetails", {
					TransferPaymentsToAgency: !paymentDetails.TransferPaymentsToAgency,
				}),
		});
	};

	/** Gets a list of payment rules used for the users payment settings */
	getPaymentRules = () => {
		const { lang } = global;
		const { params, location } = this.props;
		const isNewJob =
			!params?.jobId &&
			!location.query?.jobId &&
			!location.query?.requestId &&
			!location.query?.draftId;

		OrganizationService.getJurisdictionPaymentRules()
			.then(({ data }) => {
				const { TransferPaymentToJurisdiction, TransferPaymentsToAgencyOption } = data;
				this.setState(prevState => ({
					agencyPaymentInvoiceSettings: {
						...prevState.agencyPaymentInvoiceSettings,
						TransferPaymentToJurisdiction,
						TransferPaymentsToAgencyOption,
					},
				}));
				// Prefill transfer payments to agency option based on jurisdiction rule settings
				if (isNewJob)
					this.updateForm("paymentDetails", {
						TransferPaymentsToAgency: TransferPaymentsToAgencyOption || false,
					});
			})
			.catch(() =>
				utils.notify({
					type: "error",
					message: lang.t("Error getting Jurisdiction Payment Rules"),
					timeOut: 1500,
				}),
			);
	};

	getAgencyRules = async () => {
		const { lang } = global;
		OrganizationService.getJurisdictionAgencyRules()
			.then(({ data }) => {
				const {
					OnlyAuthorizedClientsAreAllowedToUseVehicles,
					RequireInvoicingForVehicles,
				} = data;
				this.setState(() => ({
					agencyRules: {
						OnlyAuthorizedClientsAreAllowedToUseVehicles,
						RequireInvoicingForVehicles,
					},
				}));
			})
			.catch(() =>
				utils.notify({
					type: "error",
					message: lang.t("Error getting Jurisdiction Agency Rules"),
					timeOut: 1500,
				}),
			);
	};

	shouldAddPositionWhenContinue = fieldsToValidate => {
		const {
			isJobEvent,
			positionName,
			positionStartDate,
			officersNeeded,
			officerRate,
			positionStartTime,
			positionEndTime,
			positionRate,
			PayCodeId,
		} = fieldsToValidate;

		this.validateSelectedPayCodes();

		if (
			(isJobEvent &&
				positionName.trim() !== "" &&
				positionStartDate.trim() !== "" &&
				officersNeeded.toString().trim() !== "" &&
				positionStartTime.trim() !== "" &&
				positionEndTime.trim() !== "") ||
			(!isJobEvent &&
				positionName.trim() !== "" &&
				officersNeeded.toString().trim() !== "" &&
				((positionRate === PAY_RATE_TYPE.HOURLY && officerRate.toString().trim() !== "") ||
					(positionRate === PAY_RATE_TYPE.PAY_CODE && !!PayCodeId)))
		) {
			this.validateSection("positions", true);
			return true;
		}

		return false;
	};

	openForcedVehicleInvoicingModal = () => {
		const { lang } = global;
		this.confirmationModal.openModal({
			title: lang.t("Invoicing Required with Vehicles"),
			message: lang.t("Vehicle Invoicing Required Modal Message"),
			confirmButton: lang.t("OK"),
			hideCancel: true,
			onConfirm: () => {},
		});
	};

	onJobEventTypeChange = event => {
		const {
			form: {
				generalInfo: { _isRecurring, JobEventTypeId },
			},
		} = this.state;

		if (event.value === JobEventTypeId) {
			return;
		}

		const isEvent = event.value === FORM_JOB_TYPES.EVENT.value;

		const updates = {
			JobEventTypeId: event.value,
		};

		if (isEvent) {
			updates._isRecurring = false;
			updates._startTime = "";
			updates._endTime = "";
			updates._flexJob = false;
			updates._flexJobMinHours = "";
			updates.JobEventRecurrenceRule = {
				RepeatType: 1,
				RepeatsOn: [],
				StartsOn: "",
				EndType: "NEVER",
				EndsAfterOccurrence: "",
				EndsOn: "",
				WeekFrequency: "1",
			};
		}

		// If the JobEventTypeId is anything other than an event and flex shifts have been added to a position we need to reset those values
		if (event.value !== JobEventTypeId && (JobEventTypeId === 6 || event.value === 6)) {
			this.resetFlexJob();
		}

		this.updateForm("generalInfo", updates, _isRecurring);
	};

	PaymentDetailsPanel = ({ isNewJob }) => {
		const { lang } = global;
		const { user } = this.props;

		const {
			form: { generalInfo, positions, paymentDetails },
			agencyRules: { RequireInvoicingForVehicles },
			clientContacts,
			isPaymentDetailsValid,
			positionWithPayCodeExist,
			agencyPaymentInvoiceSettings,
			loadingClients,
			clients,
		} = this.state;

		return (
			<CollapsiblePanel
				title={lang.t("Payment Details")}
				subTitle={lang.t("How the officer(s) will be paid for their services")}
				expanded={paymentDetails._expanded}
				verified={isPaymentDetailsValid}
				handleToggle={() => this.handleToggleSection("paymentDetails")}
			>
				<PaymentDetails
					form={paymentDetails}
					user={user}
					isNewJob={isNewJob}
					clientContacts={clientContacts}
					updateForm={this.updateForm}
					validateSection={this.validateSection}
					expandNextSection={this.expandNextSection}
					openQuickAddContactModal={this.openQuickAddContactModal}
					closeModal={this.closeQuickAddContactModal}
					getClientContacts={() => this.getContacts(generalInfo._clientId)}
					positionWithPayCodeExist={positionWithPayCodeExist}
					updateTransferPaymentsToAgency={this.updateTransferPaymentsToAgency}
					transferPaymentToJurisdictionEnabled={
						agencyPaymentInvoiceSettings.TransferPaymentToJurisdiction
					}
					transferPaymentsToAgencyRuleEnabled={
						agencyPaymentInvoiceSettings.TransferPaymentsToAgencyOption
					}
					clients={clients}
					clientId={generalInfo._clientId}
					loadingClients={loadingClients}
					requireInvoicingForVehicles={RequireInvoicingForVehicles}
					jobs={positions.Jobs}
					openForcedVehicleInvoicingModal={this.openForcedVehicleInvoicingModal}
				/>
			</CollapsiblePanel>
		);
	};

	InvoicingDetailsPanel = ({ isNewJob }) => {
		const { lang } = global;
		const { user } = this.props;

		const {
			form: { generalInfo, positions, paymentDetails },
			agencyRules: {
				OnlyAuthorizedClientsAreAllowedToUseVehicles,
				RequireInvoicingForVehicles,
			},
			clientContacts,
			isPaymentDetailsValid,
			positionWithPayCodeExist,
			agencyPaymentInvoiceSettings,
			loadingClients,
			clients,
			jobEditingProperties,
			loadingSchedulingOptions,
			isClientEnforceV2NonRKPayInvoicing,
		} = this.state;

		return (
			<CollapsiblePanel
				title={lang.t("Invoicing Details")}
				subTitle={lang.t("How the client will be invoiced for this job")}
				expanded={paymentDetails._expanded}
				verified={isPaymentDetailsValid}
				handleToggle={() => this.handleToggleSection("paymentDetails")}
				dataTestId="jobs__invoicing-details-section"
			>
				<InvoicingDetails
					form={paymentDetails}
					generalForm={generalInfo}
					user={user}
					isNewJob={isNewJob}
					clientContacts={clientContacts}
					updateForm={this.updateForm}
					validateSection={this.validateSection}
					expandNextSection={this.expandNextSection}
					openQuickAddContactModal={this.openQuickAddContactModal}
					closeModal={this.closeQuickAddContactModal}
					getClientContacts={() => this.getContacts(generalInfo._clientId)}
					positionWithPayCodeExist={positionWithPayCodeExist}
					updateTransferPaymentsToAgency={this.updateTransferPaymentsToAgency}
					transferPaymentToJurisdictionEnabled={
						agencyPaymentInvoiceSettings?.TransferPaymentToJurisdiction || false
					}
					transferPaymentsToAgencyRuleEnabled={
						agencyPaymentInvoiceSettings?.TransferPaymentsToAgencyOption || false
					}
					clients={clients}
					clientId={generalInfo._clientId}
					loadingClients={loadingClients}
					onlyAuthorizedClientsAreAllowedToUseVehicles={
						OnlyAuthorizedClientsAreAllowedToUseVehicles
					}
					requireInvoicingForVehicles={RequireInvoicingForVehicles}
					jobs={positions.Jobs}
					openForcedVehicleInvoicingModal={this.openForcedVehicleInvoicingModal}
					confirmationModal={this.confirmationModal}
					jobEditingProperties={jobEditingProperties}
					getClients={this.getClients}
					onClientChange={this.onClientChange}
					onContinue={() => this.getJobEstimate(undefined)}
					isInvoicingFirstEnabled={this.isInvoicingFirstEnabled}
					loadingSchedulingOptions={loadingSchedulingOptions}
					loadJobInvoiceOnlyOptions={this.loadJobInvoiceOnlyOptions}
					enforceV2NonRKPayInvoicingEnabled={this.enforceV2NonRKPayInvoicingEnabled}
					isClientEnforceV2NonRKPayInvoicing={isClientEnforceV2NonRKPayInvoicing}
					setIsClientEnforceV2NonRKPayInvoicing={
						this.setIsClientEnforceV2NonRKPayInvoicing
					}
				/>
			</CollapsiblePanel>
		);
	};

	validateSelectedPayCodes() {
		const { lang } = global;
		const {
			agencyPayCodes,
			form: {
				generalInfo,
				positions: { Jobs },
			},
		} = this.state;
		const isJobEvent = generalInfo.JobEventTypeId === FORM_JOB_TYPES.EVENT.value;
		let newPositions = [...Jobs];
		const agencyPayCodesIds = agencyPayCodes.map(p => p.value);
		const selectedPayCodesIds = Jobs.filter(job => !!job.PayCodeId).map(job => job.PayCodeId);
		const positionsWithoutPayCodeOrRate = Jobs.filter(
			job => !job.PayCodeId && !utils.isPayRateValid(job.Rate),
		);
		const _isSelectedPaycodesInRange =
			selectedPayCodesIds.length === 0
				? true
				: selectedPayCodesIds.every(paycodeId => agencyPayCodesIds.includes(paycodeId));

		if (isJobEvent) return;
		if (agencyPayCodesIds.length === 0) return;

		if (!_isSelectedPaycodesInRange) {
			utils.notify({
				type: "error",
				message: lang.t(
					"One or more selected positions have a pay code outside the start date range, please change it to a valid one",
				),
				timeOut: 1500,
			});

			newPositions = newPositions.map(position => {
				if (
					!agencyPayCodesIds.includes(position.PayCodeId) &&
					!utils.isPayRateValid(position.Rate)
				) {
					return {
						...position,
						PayCodeId: "",
						_isValid: false,
					};
				}
				return position;
			});

			this.updateForm("positions", { Jobs: newPositions, _expanded: true });
			this.validateSection("positions", false);
		} else if (Jobs.length === 0) {
			this.validateSection("positions", false);
		} else if (positionsWithoutPayCodeOrRate.length > 0) {
			newPositions = newPositions.map(position => {
				if (!position.PayCodeId && !utils.isPayRateValid(position.Rate)) {
					return {
						...position,
						_isValid: false,
					};
				}
				return position;
			});

			this.updateForm("positions", { Jobs: newPositions });
			this.validateSection("positions", false);
		} else {
			newPositions = newPositions.map(position => ({
				...position,
				_isValid: true,
			}));

			this.updateForm("positions", { Jobs: newPositions });
			this.validateSection("positions", true);
		}
	}

	render() {
		const { lang } = global;
		const {
			user,
			params,
			location,
			router: { push },
		} = this.props;
		const {
			pageTitle,
			draftButtonState,
			saveButtonState,
			estimateButtonState,
			loadingForm,
			loaderEntireScreen,
			loadingEstimate,
			showSendEstimateModal,
			estimateJurisdictionName,
			estimatePostOption,
			clientContacts,
			form: { generalInfo, positions, paymentDetails, officerFulfillment },
			isGeneralInfoValid,
			isPositionsValid,
			isPaymentDetailsValid,
			isOfficerFulfillmentValid,
			invoiceEstimate,
			locationCoordinates,
			estimateInfo,
			jobEditingProperties,
			agencyContacts,
			jobRequestProperties,
			showInvalidFields,
			showPositionFormModal,
			agencyRules: {
				OnlyAuthorizedClientsAreAllowedToUseVehicles,
				RequireInvoicingForVehicles,
			},
			activePositionIndex,
			activePositionGroup,
			seriesConfirmationModal,
			isJobPaidFor,
			showAddContactModal,
			addContactModalType,
			positionName,
			positionStartDate,
			positionEndDate,
			officersNeeded,
			officerRate,
			positionStartTime,
			positionEndTime,
			agencyEstimateList,
			showAgencyV3Options,
			isJobCompleted,
			isPositionValid,
			isEditingDate,
			newDate,
			positionRate,
			PayCodeId,
			applyPTAEOcode,
			agencyPayCodes,
			PTAEOCodeId,
			agencyPTAEOCodes,
			rawAgencyPayCodes,
			positionWithPayCodeExist,
			positionFilter,
			clients,
			loadingClients,
			projects,
			locations,
			loadingProjects,
			loadingLocations,
			isClientEnforceV2NonRKPayInvoicing,
		} = this.state;

		const { RequirePrepayment } = paymentDetails;

		const {
			AvgRate = 0,
			TotalOfficers = 0,
			JurisdictionFees = [],
			TotalOfficerPay = 0,
			TotalOrganizationFee = 0,
			TotalJurisdictionFee = 0,
			RKPayFee = 0,
			WorkerCompensationFee = 0,
			Total = 0,
			WeeklyTotal = 0,
			RecurrenceTotal = null,
		} = estimateInfo;

		const {
			Organization: {
				JobAutoAssignType,
				JobAutoAssignHoursSpan,
				JobAutoAssignJobCountDaysSpan,
				JobAutoAssignQueueCycleMaxAssignments,
				JobAutoAssignYearToDateSpan,
				PayCodesEnabled,
				IsPayCodeMandatory,
			},
		} = user;

		const agencyAutoAssignPresets = {
			JobAutoAssignType,
			JobAutoAssignHoursSpan,
			JobAutoAssignJobCountDaysSpan,
			JobAutoAssignQueueCycleMaxAssignments,
			JobAutoAssignYearToDateSpan,
		};

		const isFormValid =
			isGeneralInfoValid &&
			isPositionsValid &&
			isPaymentDetailsValid &&
			isOfficerFulfillmentValid;
		const isInvoicingV3 = user.Features.some(f => f.toLowerCase() === "invoicingv3");
		const officerInvoicingV3EnabledForOrg = user.Features.some(f =>
			f.toLowerCase().includes("officerinvoicingv3"),
		);
		const isJobEvent = generalInfo.JobEventTypeId === FORM_JOB_TYPES.EVENT.value;
		const jobEventHasOfficers = positions.Jobs.some(pos => pos._hasAssignedOfficers);
		const addToButtonState =
			(isJobCompleted && !jobEventHasOfficers && jobEditingProperties.Id && isInvoicingV3) ||
			paymentDetails.JobInvoicedTypeId === 3
				? "disabled"
				: estimateButtonState;
		const positionDates = [
			...new Set(positions.Jobs.map(({ _positionStartDate }) => _positionStartDate)),
		].sort();

		return (
			<div
				className={`container${showInvalidFields ? " invalid-fields" : ""}`}
				id="job-form"
				data-test-id="job__form-container"
			>
				<div className="row">
					<div className="col-sm-6 col-md-5 form-heading">
						<h2>{pageTitle}</h2>
						<span className="required-mark" />
						<em>&nbsp;indicates a required field</em>
					</div>
					<div className="col-sm-6 col-md-7 form-heading">
						<a
							href="mailto:info@rollkall.com"
							className="btn feedback-button"
						>
							<i className="rkf rkf-user-message" />
							<span className="feedback-text">
								{lang.t("Give us feedback on this experience")}
							</span>
						</a>
					</div>
				</div>
				<div
					className="row"
					id="job-form-body"
					data-test-id="job__form-body"
				>
					<div
						className="col-md-8"
						id="form-sections"
						ref={this.formSections}
					>
						<If condition={this.isInvoicingFirstEnabled}>
							<this.InvoicingDetailsPanel isNewJob={this.isNewJob} />
						</If>
						<CollapsiblePanel
							title={lang.t("General Job Information")}
							subTitle={lang.t("Basic details for this job")}
							expanded={generalInfo._expanded}
							verified={isGeneralInfoValid}
							handleToggle={() => this.handleToggleSection("generalInfo")}
							dataTestId="job__general-info-section"
						>
							<GeneralInformation
								form={generalInfo}
								isNewJob={this.isNewJob}
								jobEditingProperties={jobEditingProperties}
								jobRequestProperties={jobRequestProperties}
								user={user}
								agencyContacts={agencyContacts}
								clientContacts={clientContacts}
								loadingForm={loadingForm}
								finishLoadingForm={this.finishLoadingForm}
								updateLocationCoordinates={this.updateLocationCoordinates}
								updateForm={this.updateForm}
								updateRequestProperties={this.updateRequestProperties}
								expandNextSection={this.expandNextSection}
								validateSection={this.validateSection}
								getContacts={this.getContacts}
								openQuickAddContactModal={this.openQuickAddContactModal}
								closeModal={this.closeQuickAddContactModal}
								jobEndDate={positionEndDate}
								getClients={this.getClients}
								clients={clients}
								loadingClients={loadingClients}
								isInvoicingFirstEnabled={this.isInvoicingFirstEnabled}
								projects={projects}
								locations={locations}
								loadingProjects={loadingProjects}
								loadingLocations={loadingLocations}
								getProjects={this.getProjects}
								getLocations={this.getLocations}
								setLocations={items => this.setState({ locations: items })}
								onClientChange={this.onClientChange}
								onJobEventTypeChange={this.onJobEventTypeChange}
								location={location}
							/>
						</CollapsiblePanel>
						<CollapsiblePanel
							title={lang.t("Positions")}
							subTitle={lang.t("Add position(s) and provide details")}
							expanded={positions._expanded}
							verified={isPositionsValid}
							handleToggle={() => this.handleToggleSection("positions")}
							class="position-container"
							dataTestId="jobs__positions-section"
						>
							<div className="row">
								<div className="col-sm-4 col-xs-6 position-filter-container">
									<ReactSelect
										id="position-filter"
										value={positionFilter}
										name="position-filter"
										onChange={this.onPositionFilterChange}
										options={positionFilterOptions}
										isLoading={false}
										isDisabled={false}
										placeholder="Sort By"
										dataTestId="jobs__position-filter"
									/>
								</div>
							</div>
							<Choose>
								<When condition={isJobEvent}>
									<For
										each="date"
										of={positionDates}
									>
										<div
											className="position-date"
											key={`positionStartDate_${date}`}
										>
											<div className="row">
												<div className="col-sm-12 date-actions">
													<span
														role="button"
														tabIndex="0"
														onClick={() => {
															this.setEditingDate(date);
														}}
														onKeyPress={e => {
															if (e.key === "Enter") {
																e.stopPropagation();
																// duplicatePosition();
															}
														}}
													>
														<If condition={isEditingDate === date}>
															<input
																type="date"
																value={newDate}
																data-test-id="jobs__position-date-input"
																ref={input => {
																	this.dateChangeInput = input;
																}}
																onChange={e =>
																	this.updatePositionDate(date, e)
																}
																onBlur={e =>
																	this.updatePositionDate(
																		date,
																		e,
																		true,
																	)
																}
																onKeyPress={e => {
																	if (e.key === "Enter") {
																		this.updatePositionDate(
																			date,
																			e,
																			true,
																		);
																	}
																}}
															/>
														</If>
														<Choose>
															<When condition={utils.isDesktopSafari}>
																<strong
																	className={
																		isEditingDate === date
																			? "hidden"
																			: "date-display"
																	}
																>
																	{utils.formatDate(
																		new Date(`${date}`),
																		"en-US",
																		user.TimeZoneId,
																		"w-long",
																	)}
																</strong>
															</When>
															<Otherwise>
																<strong
																	className={
																		isEditingDate === date
																			? "hidden"
																			: "date-display"
																	}
																>
																	{utils.formatDate(
																		new Date(
																			`${date}T00:00:00`,
																		),
																		"en-US",
																		user.TimeZoneId,
																		"w-long",
																	)}
																</strong>
															</Otherwise>
														</Choose>
													</span>
													<button
														type="button"
														id={`duplicate-${date}`}
														data-test-id="jobs__duplicate-position-date"
														className="btn btn-link"
														onClick={e => {
															e.stopPropagation();
															this.duplicatePositionDate(date);
														}}
														onKeyPress={e => {
															if (e.key === "Enter") {
																e.stopPropagation();
																this.duplicatePositionDate(date);
															}
														}}
														title={lang.t("Duplicate")}
													>
														<i className="glyphicon glyphicon-duplicate" />
														&nbsp;
														<span className="visible-xs-inline">
															{lang.t("Duplicate")}
														</span>
													</button>
													<button
														type="button"
														id={`delete-${date}`}
														data-test-id="jobs__delete-position-date"
														className="btn btn-link"
														onClick={e => {
															e.stopPropagation();
															this.deletePositionDate(date);
														}}
														title={lang.t("Delete")}
													>
														<i className="glyphicon glyphicon-trash text-danger" />
														&nbsp;
														<span className="visible-xs-inline">
															{lang.t("Delete")}
														</span>
													</button>
												</div>
											</div>
											<For
												each="item"
												index="idx"
												of={positions.Jobs}
											>
												<If
													condition={this.doesPositionStartOnDate(
														date,
														item,
													)}
												>
													{/* <div key={`jobPosition_${item.SortOrder}`}> */}
													<PositionSummary
														key={`jobPosition_${item.SortOrder}`}
														editingJob={
															jobEditingProperties.Id !== null
														}
														position={item}
														isJobEvent={isJobEvent}
														jobPositions={positions.Jobs}
														positionGroupCount={this.getPositionGroupCount(
															item.PositionGroupId,
														)}
														positionStartDate={
															generalInfo.JobEventTypeId ===
															FORM_JOB_TYPES.EVENT.value
																? item._positionStartDate
																: generalInfo._startDate
														}
														startTime={
															generalInfo.JobEventTypeId ===
															FORM_JOB_TYPES.EVENT.value
																? item._startTime
																: generalInfo._startTime
														}
														endTime={
															generalInfo.JobEventTypeId ===
															FORM_JOB_TYPES.EVENT.value
																? item._endTime
																: generalInfo._endTime
														}
														onEdit={() => {
															this.togglePositionFormModal(
																idx,
																item.PositionGroupId,
															);
														}}
														onDelete={() => this.deletePosition(idx)}
														updateForm={this.updateForm}
														user={user}
														agencyPayCodes={agencyPayCodes}
														agencyPTAEOCodes={agencyPTAEOCodes}
														rawAgencyPayCodes={rawAgencyPayCodes}
														sortOrder={item.SortOrder}
														activePositionIndex={activePositionIndex}
														validateSection={this.validateSection}
													/>
													{/* </div> */}
												</If>
											</For>
										</div>
									</For>
								</When>
								<Otherwise>
									<div className="nonevent-position">
										<For
											each="item"
											index="idx"
											of={positions.Jobs}
										>
											<PositionSummary
												key={`jobPosition_${item.SortOrder}`}
												editingJob={jobEditingProperties.Id !== null}
												position={item}
												isJobEvent={isJobEvent}
												jobPositions={positions.Jobs}
												positionGroupCount={this.getPositionGroupCount(
													item.PositionGroupId,
												)}
												positionStartDate={
													generalInfo.JobEventTypeId ===
													FORM_JOB_TYPES.EVENT.value
														? item._positionStartDate
														: generalInfo._startDate
												}
												startTime={
													generalInfo.JobEventTypeId ===
													FORM_JOB_TYPES.EVENT.value
														? item._startTime
														: generalInfo._startTime
												}
												endTime={
													generalInfo.JobEventTypeId ===
													FORM_JOB_TYPES.EVENT.value
														? item._endTime
														: generalInfo._endTime
												}
												onEdit={() =>
													this.togglePositionFormModal(
														idx,
														item.PositionGroupId,
													)
												}
												onDelete={() => this.deletePosition(idx)}
												updateForm={this.updateForm}
												user={user}
												agencyPayCodes={agencyPayCodes}
												agencyPTAEOCodes={agencyPTAEOCodes}
												rawAgencyPayCodes={rawAgencyPayCodes}
												sortOrder={item.SortOrder}
												activePositionIndex={activePositionIndex}
												validateSection={this.validateSection}
											/>
										</For>
									</div>
								</Otherwise>
							</Choose>
							<div className="add-position sticky">
								<PositionSummaryForm
									positionName={positionName}
									isPositionValid={isPositionValid}
									handlePositionChanges={this.handlePositionChanges}
									savePosition={this.addPosition}
									officersNeeded={officersNeeded}
									isJobEvent={isJobEvent}
									positionStartDate={positionStartDate}
									positionStartTime={positionStartTime}
									positionEndTime={positionEndTime}
									user={user}
									militaryTimeMask={this.militaryTimeMask}
									generalInfoStartTime={generalInfo._startTime}
									generalInfoEndTime={generalInfo._endTime}
									formatPositionTime={this.formatPositionTime}
									PayCodesEnabled={PayCodesEnabled}
									IsPayCodeMandatory={IsPayCodeMandatory}
									handleCheckboxChange={this.handleCheckboxChange}
									positionRate={positionRate}
									officerRate={officerRate}
									PayCodeId={PayCodeId}
									handleSelectChange={this.handleSelectChange}
									agencyPayCodes={agencyPayCodes}
									agencyPTAEOCodes={agencyPTAEOCodes}
									PTAEOCodeId={PTAEOCodeId}
									onCancel={undefined}
									saveButtonText={`+ ${lang.t("Add")}`}
									cancelButtonText={lang.t("Cancel")}
									sortOrder={0}
									positionRateRadioName="positionRate"
									applyPTAEOcode={applyPTAEOcode}
								/>
							</div>
							<div className="text-center positions-button-container">
								<button
									type="button"
									id="positions-continue"
									data-test-id="jobs__positions-continue"
									onClick={() => {
										if (
											this.shouldAddPositionWhenContinue({
												isJobEvent,
												positionName,
												positionStartDate,
												officersNeeded,
												officerRate,
												positionStartTime,
												positionEndTime,
												positionRate,
												PayCodeId,
											})
										) {
											this.addPosition();
										}
										this.expandNextSection("positions");
									}}
									className="btn btn-primary btn-big"
								>
									{lang.t("Continue")}
								</button>
							</div>
						</CollapsiblePanel>

						<If
							condition={
								!this.isInvoicingFirstEnabled &&
								this.isInvoicingDetailsComponentEnabled &&
								isInvoicingV3
							}
						>
							<this.InvoicingDetailsPanel isNewJob={this.isNewJob} />
						</If>

						<If condition={!this.isInvoicingDetailsComponentEnabled || !isInvoicingV3}>
							<this.PaymentDetailsPanel isNewJob={this.isNewJob} />
						</If>

						<CollapsiblePanel
							title="Applicant Restrictions"
							subTitle="Set up when specific agency's officers can apply to your job"
							expanded={officerFulfillment._expanded}
							verified={isOfficerFulfillmentValid}
							handleToggle={() => this.handleToggleSection("officerFulfillment")}
							dataTestId="jobs__officer-fulfillment-section"
						>
							<OfficerFulfillment
								form={officerFulfillment}
								isNewJob={this.isNewJob}
								validateSection={this.validateSection}
								updateForm={this.updateForm}
								expandNextSection={this.expandNextSection}
							/>
						</CollapsiblePanel>
						<Loader active={loadingForm} />
					</div>
					<div
						className="col-xs-10 col-xs-offset-1 col-md-4 col-md-offset-0"
						id="estimate-container"
					>
						<LocationMap
							locationCoordinates={locationCoordinates}
							ref={this.locationMap}
						/>
						<div
							id="estimate-info-container"
							data-test-id="jobs__estimate-info-container"
							ref={this.estimateContainer}
						>
							<div className="estimate-panel">
								<h4>{lang.t("Estimate")}</h4>
								<hr />
								<div className="form-group">
									<AsyncSelect
										id="estimate-jurisdiction"
										placeholder={lang.t("Type jurisdiction name")}
										noOptionsMessage={() => lang.t("No results")}
										cacheOptions
										isClearable
										loadOptions={utils.loadJurisdictions}
										onChange={this.handleJurisdictionChange}
										value={
											invoiceEstimate.ClientInvoiceEstimateJurisdictionId
												? {
														value: invoiceEstimate.ClientInvoiceEstimateJurisdictionId,
														label: estimateJurisdictionName,
													}
												: undefined
										}
										dataTestId="jobs__estimate-jurisdiction"
									/>
								</div>
								<hr />
								<div className="row">
									<div className="col-xs-6">
										<strong>{lang.t("Avg Officer Rate")}</strong>
									</div>
									<div className="col-xs-6 text-right">
										{positionWithPayCodeExist
											? "N/A"
											: `${utils.currencyFormatter(AvgRate)}/${lang.t("Hour").toLowerCase()}`}
									</div>
								</div>
								<div className="row">
									<div className="col-xs-6">
										<strong>{`${lang.t("Total")} ${lang.t("Officers")}`}</strong>
									</div>
									<div className="col-xs-6 text-right" data-test-id="jobs__total-officers">{TotalOfficers}</div>
								</div>
								<For
									each="item"
									of={JurisdictionFees}
								>
									<div
										className="row"
										key={`${item.ItemName}_${item.ItemSubtotal}`}
									>
										<div className="col-xs-6 jf-title">
											<strong>{item.ItemName}</strong>
										</div>
										<div className="col-xs-6 text-right">
											{utils.currencyFormatter(item.ItemSubtotal)}
										</div>
									</div>
								</For>
								<If condition={paymentDetails.IsRKPay || isInvoicingV3}>
									<hr />
									<Choose>
										<When
											condition={
												!paymentDetails.IsRKPay &&
												paymentDetails.JobInvoicedTypeId === 2 &&
												paymentDetails.ExcludeOfficerRate
											}
										>
											<div className="row">
												<div className="col-xs-8 dark-grey-text">
													<strong>
														{lang.t("Officer Pay Excluded")}
													</strong>
												</div>
												<div className="col-xs-4 text-right" data-test-id="jobs__officer-pay-excluded">---</div>
											</div>
										</When>
										<Otherwise>
											<div className="row">
												<div className="col-xs-6">
													<strong>{lang.t("Subtotal")}</strong>
												</div>
												<div className="col-xs-6 text-right" data-test-id="jobs__subtotal">
													{utils.currencyFormatter(TotalOfficerPay)}
												</div>
											</div>
										</Otherwise>
									</Choose>
									<div className="row">
										<div className="col-xs-6">
											<strong>{lang.t("Coordination Fees")}</strong>
										</div>
										<div className="col-xs-6 text-right" data-test-id="jobs__coordination-fees">
											{utils.currencyFormatter(TotalOrganizationFee)}
										</div>
									</div>
									<div className="row">
										<div className="col-xs-6">
											<strong>{lang.t("Jurisdiction Fees")}</strong>
										</div>
										<div className="col-xs-6 text-right" data-test-id="jobs__jurisdiction-fees">
											{utils.currencyFormatter(TotalJurisdictionFee)}
										</div>
									</div>
									<div className="row">
										<div className="col-xs-6">
											<strong>{lang.t("RollKall Fees")}</strong>
										</div>
										<div className="col-xs-6 text-right" data-test-id="jobs__rollkall-fees">
											{utils.currencyFormatter(RKPayFee)}
										</div>
									</div>
									<If condition={this.hasWorkersCompensationFee}>
										<div className="row">
											<div className="col-xs-8">
												<strong>
													{lang.t("Workers' Compensation Fee")}
												</strong>
											</div>
											<div className="col-xs-4 text-right" data-test-id="jobs__workers-compensation-fee">
												{utils.currencyFormatter(WorkerCompensationFee)}
											</div>
										</div>
									</If>
									<div className="row">
										<div className="col-xs-6">
											<strong>{lang.t("Taxes")}</strong>
											<Tooltip
												content={lang.t(
													"Taxes will be determined based on location once a job invoice or estimate has been generated",
												)}
											>
												<i className="rkf rkf-question-solid job-form-tooltip tooltip-icon" />
											</Tooltip>
										</div>
										<div className="col-xs-6 text-right">TBD</div>
									</div>
								</If>
								<hr />
								<div className="row">
									<div className="col-xs-6">
										<strong>{lang.t("Estimated Total")}</strong>
									</div>
									<div className="col-xs-6 text-right" data-test-id="jobs__estimated-total">
										{utils.currencyFormatter(Total)}
									</div>
								</div>
								<If condition={generalInfo._isRecurring}>
									<div className="row">
										<div className="col-xs-6">
											<strong>
												{RecurrenceTotal === null
													? lang.t("Weekly Total")
													: lang.t("Series Total")}
											</strong>
										</div>
										<div className="col-xs-6 text-right">
											{utils.currencyFormatter(
												RecurrenceTotal === null
													? WeeklyTotal
													: RecurrenceTotal,
											)}
										</div>
									</div>
								</If>
								<Loader active={loadingEstimate} />
							</div>
							<ProgressButton
								id="save-job-draft"
								data-test-id="jobs__save-draft-button"
								className={`btn btn-default form-progress-button${jobEditingProperties.Id ? " hidden" : ""}`}
								state={draftButtonState}
								onClick={this.saveDraft()}
							>
								{`${location.query?.draftId ? "Update" : "Save"} Draft`}
							</ProgressButton>
							<ProgressButton
								id="save-job-form"
								data-test-id="jobs__save-job-button"
								className={`btn btn-primary form-progress-button${RequirePrepayment && isFormValid && !isJobPaidFor ? " hidden" : ""}`}
								state={saveButtonState}
								onClick={() => this.handleSave()}
							>
								{lang.t("Save Job")}
							</ProgressButton>
							<If
								condition={
									this.relocateJobFormAddToInvoicingV3Button && !isJobPaidFor
								}
							>
								<If
									condition={
										!officerInvoicingV3EnabledForOrg && paymentDetails.IsRKPay
									}
								>
									<SendEstimateButton
										buttonState={addToButtonState}
										dataTestId="jobs__send-estimate-rk-pay-button"
										handleSave={() => this.handleSave(true)}
									/>
								</If>
							</If>
							<If
								condition={
									!this.relocateJobFormAddToInvoicingV3Button && !isJobPaidFor
								}
							>
								<If
									condition={
										isInvoicingV3 &&
										!paymentDetails.IsRKPay &&
										paymentDetails.JobInvoicedTypeId != JOB_INVOICED_TYPES.OFFICER_INVOICING &&
										!isClientEnforceV2NonRKPayInvoicing
									}
								>
									<ProgressButton
										id="send-job-estimate"
										data-test-id="jobs__set-agency-estimate-list"
										className="btn btn-primary form-progress-button"
										state={addToButtonState}
										onClick={() => this.setAgencyEstimateList()}
									>
										{lang.t(
											isJobCompleted ? "Add to Invoice" : "Add to Estimate",
										)}
									</ProgressButton>
								</If>
								<If
									condition={
										!officerInvoicingV3EnabledForOrg && paymentDetails.IsRKPay
									}
								>
									<SendEstimateButton
										buttonState={addToButtonState}
										dataTestId="jobs__rk-v3-pay-button"
										handleSave={() => this.handleSave(true)}
									/>
								</If>
							</If>
							<If condition={showAgencyV3Options}>
								<ul
									id="agency-estimate-options"
									className="list-group"
								>
									<li
										// eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
										role="button"
										tabIndex="0"
										className="list-group-item"
										onMouseOver={this.handleEstimateHover}
										onFocus={this.handleEstimateHover}
										onClick={() => this.addToV3Invoice()}
										data-test-id="jobs__add-to-v3-invoice-button"
										onKeyDown={this.handleKeyDown}
										onKeyPress={({ key }) => {
											if (key === "Enter") this.addToV3Invoice();
										}}
									>
										<div>
											+{" "}
											{lang.t(
												isJobCompleted ? "New Invoice" : "New Estimate",
											)}
										</div>
									</li>
									<For
										each="estimate"
										of={agencyEstimateList}
									>
										<li
											key={`manual-est-${estimate.Id}`}
											// eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
											role="button"
											tabIndex="0"
											className="list-group-item"
											onMouseOver={this.handleEstimateHover}
											onFocus={this.handleEstimateHover}
											onClick={() => this.addToV3Invoice(estimate.Id)}
											onKeyDown={this.handleKeyDown}
											onKeyPress={({ key }) => {
												if (key === "Enter")
													this.addToV3Invoice(estimate.Id);
											}}
										>
											<div>{estimate.InvoiceNumber}</div>
											<div className="text-right text-muted">
												{lang.t("Issued")}{" "}
												{utils.formatDate(
													`${estimate.IssueDate}`,
													"en-US",
													user.TimeZoneId,
													"short",
												)}
											</div>
										</li>
									</For>
								</ul>
							</If>
						</div>
					</div>
				</div>
				<ConfirmationModal
					ref={ref => {
						this.confirmationModal = ref;
					}}
				/>
				<AddContactModal
					showModal={showAddContactModal}
					closeModal={this.closeQuickAddContactModal}
					clientId={
						addContactModalType === "contacts" ? generalInfo._clientId : undefined
					}
					organizationId={
						addContactModalType !== "contacts" ? user.Organization.Id : undefined
					}
				/>
				<SeriesConfirmationModal
					show={seriesConfirmationModal.show}
					actionType={seriesConfirmationModal.actionType}
					onConfirm={seriesConfirmationModal.onConfirm}
					onClose={seriesConfirmationModal.onClose}
				/>
				<ConflictsModal
					timeZoneId={user.TimeZoneId}
					ref={ref => {
						this.conflictsModal = ref;
					}}
					user={user}
				/>
				<SendEstimateModal
					invoiceEstimate={invoiceEstimate}
					estimatePostOption={estimatePostOption}
					requirePrepayment={RequirePrepayment}
					clientId={generalInfo._clientId}
					jobDate={generalInfo._startDate}
					estimateTotal={Total}
					showModal={showSendEstimateModal}
					clientContacts={clientContacts}
					agencyAutoAssignPresets={agencyAutoAssignPresets}
					jobId={params?.jobId}
					openQuickAddContactModal={this.openQuickAddContactModal}
					getContacts={this.getContacts}
					user={user}
					handleEstimateModalFormChange={this.handleEstimateModalFormChange}
					handleJobCreation={this.handleJobCreation}
					closeModal={this.closeSendEstimateModal}
				/>
				<PositionFormModal
					show={showPositionFormModal}
					positionIndex={activePositionIndex}
					positionGroup={activePositionGroup}
					onHide={this.togglePositionFormModal}
					isJobEvent={generalInfo.JobEventTypeId === FORM_JOB_TYPES.EVENT.value}
					editingJob={jobEditingProperties.Id !== null}
					Jobs={positions.Jobs}
					minStartDate={utils.formatDate(new Date())}
					jobStartTime={generalInfo._startTime}
					updateForm={this.updateForm}
					validateSection={this.validateSection}
					confirmationModal={this.confirmationModal}
					user={user}
					push={push}
					rawAgencyPayCodes={rawAgencyPayCodes}
					generalInfoStartDate={
						generalInfo.JobEventTypeId === FORM_JOB_TYPES.EVENT.value
							? null
							: generalInfo._startDate
					}
					clients={clients}
					clientId={generalInfo._clientId}
					OnlyAuthorizedClientsAreAllowedToUseVehicles={
						OnlyAuthorizedClientsAreAllowedToUseVehicles
					}
					RequireInvoicingForVehicles={RequireInvoicingForVehicles}
				/>
				<Loader active={loaderEntireScreen} />
			</div>
		);
	}
}

const mapStateToProps = ({ app: { user } }) => ({ user });

Form.propTypes = {
	user: PropTypes.object.isRequired,
	router: PropTypes.object.isRequired,
	params: PropTypes.object,
	flags: PropTypes.object.isRequired,
	location: PropTypes.object,
};

Form.defaultProps = {
	params: {},
	location: {},
};

export default withLDConsumer()(connect(mapStateToProps)(Form));
